"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _commonPricings = require("./commonPricings");
var _sofaCreation = require("./sofaCreation");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
// *** Version: 13 ***
// when adding new fields do not forget to update pricingItems in locales with translations

/* eslint max-len: 0, object-curly-newline: 0 */

/** @param { import("../entities/types").RawPricingPiece } rawPricing */
var rawPricing = [{
  name: 'Manteau & veste',
  slug: 'mant',
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Habillé'
  }],
  hasMostCommonCategory: true,
  categories: [{
    name: 'Retoucher',
    slug: 'alteration',
    subCategories: [{
      name: 'Cintrer',
      slug: 'cin_alteration',
      items: [{
        name: 'Épaules (x2)',
        prices: {
          SIMPLE: 47,
          COMPLEX: 62
        },
        id: '13.mant-ret-cin-1',
        potentialFabrics: ['suit_intermediate']
      }, {
        name: 'Manches (x2)',
        prices: {
          SIMPLE: 49,
          COMPLEX: 59
        },
        id: '13.mant-ret-cin-2',
        potentialFabrics: ['suit_intermediate']
      }, {
        name: 'Taille',
        prices: {
          SIMPLE: 37,
          COMPLEX: 50
        },
        id: '13.mant-ret-cin-3',
        potentialFabrics: ['suit_intermediate']
      }, {
        name: 'Dos',
        prices: {
          SIMPLE: 20,
          COMPLEX: 27
        },
        id: '13.mant-ret-cin-4',
        mostCommonCategoryPosition: 2,
        mostCommonCategoryLabel: 'Cintrer dos',
        potentialFabrics: ['suit_intermediate']
      }]
    }, {
      name: 'Élargir',
      slug: 'ela_alteration',
      items: [{
        name: 'Épaules (x2)',
        prices: {
          SIMPLE: 52,
          COMPLEX: 70
        },
        id: '13.mant-ret-ela-1',
        potentialFabrics: ['suit_intermediate']
      }, {
        name: 'Manches (x2)',
        prices: {
          SIMPLE: 64,
          COMPLEX: 64
        },
        id: '13.mant-ret-ela-2',
        potentialFabrics: ['suit_intermediate']
      }, {
        name: 'Taille',
        prices: {
          SIMPLE: 46,
          COMPLEX: 61
        },
        id: '13.mant-ret-ela-3',
        potentialFabrics: ['suit_intermediate']
      }, {
        name: 'Dos',
        prices: {
          SIMPLE: 25,
          COMPLEX: 33
        },
        id: '13.mant-ret-ela-4',
        potentialFabrics: ['suit_intermediate']
      }]
    }, {
      name: 'Raccourcir',
      slug: 'rac_alteration',
      items: [{
        name: 'Longueur',
        prices: {
          SIMPLE: 29,
          COMPLEX: 41
        },
        id: '13.mant-ret-rac-1',
        mostCommonCategoryPosition: 1,
        mostCommonCategoryLabel: 'Raccourcir longueur',
        potentialFabrics: ['suit_intermediate']
      }, {
        name: 'Manche (x2 - par le bas)',
        prices: {
          SIMPLE: 25,
          COMPLEX: 30
        },
        id: '13.mant-ret-rac-2'
      }, {
        name: 'Manche (x2 - par l’épaule)',
        prices: {
          SIMPLE: 65,
          COMPLEX: 80
        },
        id: '13.mant-ret-rac-3',
        potentialFabrics: ['suit_intermediate']
      }, {
        name: 'Zara: Manche (avec boutonnières d\'origine) x2 par le bas - NE PAS refaire les boutonnières',
        prices: {
          SIMPLE: 30,
          COMPLEX: 30
        },
        isPrivate: true,
        id: '13.mant-ret-rac-4'
      }, {
        name: 'Zara: Manche (avec boutonnières d\'origine) x2 par le bas - REFAIRE les boutonnières',
        prices: {
          SIMPLE: 40,
          COMPLEX: 40
        },
        isPrivate: true,
        id: '13.mant-ret-rac-5'
      }, {
        name: 'Manche (avec boutonnières d\'origine) x2 par le bas - NE PAS refaire les boutonnières',
        prices: {
          SIMPLE: 30,
          COMPLEX: 30
        },
        isPrivate: true,
        id: '13.mant-ret-rac-6'
      }, {
        name: 'Manche (avec boutonnières d\'origine) x2 par le bas - REFAIRE les boutonnières',
        prices: {
          SIMPLE: 40,
          COMPLEX: 40
        },
        isPrivate: true,
        id: '13.mant-ret-rac-7'
      }]
    }, {
      name: 'Rallonger',
      slug: 'ral_alteration',
      items: [{
        name: 'Longueur',
        prices: {
          SIMPLE: 35,
          COMPLEX: 47
        },
        id: '13.mant-ret-ral-1',
        potentialFabrics: ['suit_intermediate']
      }, {
        name: 'Manche (x2 - par le bas)',
        prices: {
          SIMPLE: 27,
          COMPLEX: 52
        },
        id: '13.mant-ret-ral-2'
      }, {
        name: 'Manche (x2 - par l’épaule)',
        prices: {
          SIMPLE: 85,
          COMPLEX: 110
        },
        id: '13.mant-ret-ral-3'
      }]
    }, (0, _commonPricings.getCommunZipsAlteration)({
      slug: 'mant'
    }), (0, _commonPricings.getCommunButtonsAlteration)({
      slug: 'mant'
    }), {
      name: 'Plus de retouches',
      slug: 'more_alteration',
      items: [{
        name: 'Passant (x1) : ajout / retrait',
        prices: {
          SIMPLE: 8,
          COMPLEX: 8
        },
        id: '13.mant-ret-div-1',
        multiple: true
      }, {
        name: 'Pince (x1) : ajout / retrait',
        prices: {
          SIMPLE: 12,
          COMPLEX: 12
        },
        id: '13.mant-ret-div-2',
        multiple: true
      }, {
        name: 'Fente : ajout / retrait',
        prices: {
          SIMPLE: 18,
          COMPLEX: 30
        },
        id: '13.mant-ret-div-3'
      }, {
        name: 'Élastique : ajout',
        prices: {
          SIMPLE: 17,
          COMPLEX: 17
        },
        id: '13.mant-ret-div-4'
      }, {
        name: 'Perlage (5 à 10 perles)',
        prices: {
          SIMPLE: 17,
          COMPLEX: 17
        },
        id: '13.mant-ret-div-5',
        multiple: true
      }, {
        name: 'Poche plate simple (x1) : ajout/retrait',
        prices: {
          SIMPLE: 15,
          COMPLEX: 20
        },
        id: '13.mant-ret-div-6',
        multiple: true
      }, {
        name: 'Poche classique (x1) : ajout',
        prices: {
          SIMPLE: 19,
          COMPLEX: 28
        },
        id: '13.mant-ret-div-7',
        multiple: true
      }, {
        name: 'Poche complexe (x1) : ajout',
        prices: {
          SIMPLE: 22,
          COMPLEX: 32
        },
        id: '13.mant-ret-div-8',
        multiple: true,
        potentialFabrics: ['suit_intermediate']
      }, {
        name: 'Scratch < 30cm : ajout / retrait',
        prices: {
          SIMPLE: 9,
          COMPLEX: 9
        },
        id: '13.mant-ret-div-9'
      }, {
        name: 'Scratch > 30cm : ajout / retrait',
        prices: {
          SIMPLE: 11,
          COMPLEX: 11
        },
        id: '13.mant-ret-div-10'
      }, {
        name: 'Crochets (x1) : ajout / retrait',
        prices: {
          SIMPLE: 8,
          COMPLEX: 8
        },
        id: '13.mant-ret-div-11',
        multiple: true
      }, {
        name: 'Doublure : changement intégral',
        prices: {
          SIMPLE: 105,
          COMPLEX: 105
        },
        id: '13.mant-ret-div-12',
        potentialFabrics: ['suit_intermediate']
      }, {
        name: 'Doublure : changement partiel',
        prices: {
          SIMPLE: 45,
          COMPLEX: 45
        },
        id: '13.mant-ret-div-13',
        potentialFabrics: ['suit_intermediate']
      }, {
        name: 'Oeillet petit (x1) : ajout',
        prices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        id: '13.mant-ret-div-14',
        multiple: true
      }, {
        name: 'Épaulettes (x2) : ajout / retrait',
        prices: {
          SIMPLE: 21,
          COMPLEX: 38
        },
        liningPrices: {
          SIMPLE: 2
        },
        id: '13.mant-ret-div-15'
      }, {
        name: 'Couture de finition simple',
        prices: {
          SIMPLE: 4,
          COMPLEX: 6
        },
        multiple: true,
        id: '13.mant-ret-div-16',
        mostCommonCategoryPosition: 6,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition complexe',
        prices: {
          SIMPLE: 12,
          COMPLEX: 12
        },
        multiple: true,
        id: '13.mant-ret-div-17',
        mostCommonCategoryPosition: 7,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition avec empiècement',
        prices: {
          SIMPLE: 19,
          COMPLEX: 19
        },
        multiple: true,
        id: '13.mant-ret-div-18',
        mostCommonCategoryPosition: 8,
        onlyCouturiers: true
      }, {
        name: '1h de conseil',
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        id: '13.mant-ret-div-19'
      }]
    }]
  }, {
    name: 'Réparer',
    slug: 'repair',
    subCategories: [(0, _commonPricings.getCommunTearRepair)({
      slug: 'mant'
    }), (0, _commonPricings.getCommunZipsRepair)({
      slug: 'mant'
    }), (0, _commonPricings.getCommunButtonsRepair)({
      slug: 'mant'
    }), {
      name: 'Plus de réparations',
      slug: 'more_repair',
      items: [{
        name: 'Doublure : réparation / remplacement (manche x1)',
        prices: {
          SIMPLE: 45,
          COMPLEX: 65
        },
        id: '13.mant-rep-div-1',
        repairBonus: {
          SIMPLE: 'LINING_SIMPLE',
          COMPLEX: 'LINING_COMPLEX'
        },
        mostCommonCategoryPosition: 3
      }, {
        name: 'Doublure : réparation / remplacement (dos ou devant x1)',
        prices: {
          SIMPLE: 45,
          COMPLEX: 65
        },
        id: '13.mant-rep-div-2',
        repairBonus: 'LINING_COMPLEX'
      }, {
        name: 'Doublure : réparation / remplacement intégral',
        prices: {
          SIMPLE: 105,
          COMPLEX: 140
        },
        id: '13.mant-rep-div-3',
        repairBonus: 'LINING_COMPLEX'
      }, {
        name: 'Doublure - Sac de poche : réparation / remplacement',
        prices: {
          SIMPLE: 19,
          COMPLEX: 33
        },
        id: '13.mant-rep-div-4',
        repairBonus: {
          SIMPLE: 'LINING_SIMPLE',
          COMPLEX: 'LINING_COMPLEX'
        }
      }, {
        name: 'Scratch < 30cm : réparation / remplacement',
        prices: {
          SIMPLE: 9,
          COMPLEX: 9
        },
        id: '13.mant-rep-div-5'
      }, {
        name: 'Scratch > 30cm : réparation / remplacement',
        prices: {
          SIMPLE: 11,
          COMPLEX: 11
        },
        id: '13.mant-rep-div-6'
      }, {
        name: 'Crochets (x1) : réparation / remplacement',
        prices: {
          SIMPLE: 8,
          COMPLEX: 8
        },
        id: '13.mant-rep-div-7'
      }, {
        name: 'Coudière (x2)',
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        id: '13.mant-rep-div-8',
        repairBonus: 'HOLE'
      }]
    }]
  }, {
    name: 'Broder',
    slug: 'embroidery',
    subCategories: [(0, _commonPricings.getEmbroideryPricingsCategory)('mant', undefined), (0, _commonPricings.getCommunMachineEmbroidery)({
      slug: 'mant'
    })]
  }]
}, {
  name: 'Haut',
  slug: 'haut',
  hasMostCommonCategory: true,
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Habillé'
  }],
  categories: [{
    name: 'Retoucher',
    slug: 'alteration',
    subCategories: [{
      name: 'Cintrer',
      slug: 'cin_alteration',
      items: [{
        name: 'Épaules (x2)',
        prices: {
          SIMPLE: 14,
          COMPLEX: 29
        },
        id: '13.haut-ret-cin-1'
      }, {
        name: 'Manches (x2)',
        prices: {
          SIMPLE: 14,
          COMPLEX: 29
        },
        id: '13.haut-ret-cin-2'
      }, {
        name: 'Taille',
        prices: {
          SIMPLE: 14,
          COMPLEX: 25
        },
        id: '13.haut-ret-cin-3',
        potentialFabrics: ['suit_intermediate']
      }, {
        name: 'Dos',
        type: 'SIMPLE',
        prices: {
          SIMPLE: 9,
          COMPLEX: 18
        },
        id: '13.haut-ret-cin-4',
        mostCommonCategoryPosition: 5,
        mostCommonCategoryLabel: 'Cintrer dos'
      }]
    }, {
      name: 'Élargir',
      slug: 'ela_alteration',
      items: [{
        name: 'Épaules (x2)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 28
        },
        id: '13.haut-ret-ela-1'
      }, {
        name: 'Manches (x2)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 32
        },
        id: '13.haut-ret-ela-2'
      }, {
        name: 'Taille',
        prices: {
          SIMPLE: 15,
          COMPLEX: 32
        },
        id: '13.haut-ret-ela-3',
        potentialFabrics: ['suit_intermediate']
      }, {
        name: 'Dos',
        prices: {
          SIMPLE: 10,
          COMPLEX: 20
        },
        id: '13.haut-ret-ela-4'
      }]
    }, {
      name: 'Raccourcir',
      slug: 'rac_alteration',
      items: [{
        name: 'Longueur',
        prices: {
          SIMPLE: 8,
          COMPLEX: 21
        },
        id: '13.haut-ret-rac-1',
        mostCommonCategoryPosition: 4,
        mostCommonCategoryLabel: 'Raccourcir longueur',
        potentialFabrics: ['suit_intermediate']
      }, {
        name: 'Manches (x2 - par le bas)',
        infoPreview: [{
          label: 'Exemple',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739363992/ItemsPreview/low_sleeve_klmxrr.png'
        }],
        prices: {
          SIMPLE: 10,
          COMPLEX: 23
        },
        id: '13.haut-ret-rac-2'
      }, {
        name: 'Manches (x2 - par l’épaule)',
        infoPreview: [{
          label: 'Exemple',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739363992/ItemsPreview/low_sleeve_klmxrr.png'
        }],
        prices: {
          SIMPLE: 28,
          COMPLEX: 65
        },
        id: '13.haut-ret-rac-3',
        potentialFabrics: ['suit_intermediate']
      }, {
        name: 'Bretelles (x2 - par l’épaule)',
        prices: {
          SIMPLE: 8,
          COMPLEX: 18
        },
        id: '13.haut-ret-rac-4'
      }, {
        name: 'Manches par le bas (x2 - SANS boutonnière)',
        prices: {
          SIMPLE: 10,
          COMPLEX: 23
        },
        isPrivate: true,
        id: '13.haut-ret-rac-5'
      }, {
        name: 'Manches par le bas (x2 - AVEC boutonnière)',
        prices: {
          SIMPLE: 22,
          COMPLEX: 26
        },
        isPrivate: true,
        id: '13.haut-ret-rac-6'
      }]
    }, {
      name: 'Rallonger',
      slug: 'ral_alteration',
      items: [{
        name: 'Longueur',
        prices: {
          SIMPLE: 10,
          COMPLEX: 24
        },
        id: '13.haut-ret-ral-1',
        potentialFabrics: ['suit_intermediate']
      }, {
        name: 'Manches (x2 - par le bas)',
        infoPreview: [{
          label: 'Exemple',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739363992/ItemsPreview/low_sleeve_klmxrr.png'
        }],
        prices: {
          SIMPLE: 12,
          COMPLEX: 27
        },
        id: '13.haut-ret-ral-2'
      }, {
        name: 'Manches (x2 - par l’épaule)',
        infoPreview: [{
          label: 'Exemple',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739363992/ItemsPreview/low_sleeve_klmxrr.png'
        }],
        prices: {
          SIMPLE: 30,
          COMPLEX: 75
        },
        id: '13.haut-ret-ral-3'
      }]
    }, (0, _commonPricings.getCommunZipsAlteration)({
      slug: 'haut',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunButtonsAlteration)({
      slug: 'haut',
      isSuitableForJunior: true
    }), {
      name: 'Plus de retouches',
      slug: 'more_alteration',
      items: [{
        name: 'Doublure : ajout / retrait',
        prices: {
          SIMPLE: 35,
          COMPLEX: 55
        },
        id: '13.haut-ret-div-1'
      }, {
        name: 'Passant (x1) : ajout / retrait',
        prices: {
          SIMPLE: 4,
          COMPLEX: 8
        },
        id: '13.haut-ret-div-3',
        multiple: true
      }, {
        name: 'Pince (x1) : ajout',
        prices: {
          SIMPLE: 8,
          COMPLEX: 12
        },
        id: '13.haut-ret-div-4',
        multiple: true
      }, {
        name: 'Fente : ajout / retrait',
        prices: {
          SIMPLE: 12,
          COMPLEX: 18
        },
        id: '13.haut-ret-div-5',
        potentialFabrics: ['suit_intermediate']
      }, {
        name: 'Élastique : ajout',
        prices: {
          SIMPLE: 7,
          COMPLEX: 17
        },
        id: '13.haut-ret-div-6'
      }, {
        name: 'Perlage (5 à 10 perles)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 17
        },
        id: '13.haut-ret-div-7',
        multiple: true
      }, {
        name: 'Poche plate simple (x1) : ajout/retrait',
        prices: {
          SIMPLE: 10,
          COMPLEX: 15
        },
        id: '13.haut-ret-div-8',
        multiple: true
      }, {
        name: 'Poche intérieure classique (x1) : ajout',
        prices: {
          SIMPLE: 15,
          COMPLEX: 19
        },
        id: '13.haut-ret-div-9',
        multiple: true
      }, {
        name: 'Poche complexe (x1) : ajout',
        prices: {
          SIMPLE: 20,
          COMPLEX: 22
        },
        id: '13.haut-ret-div-10',
        multiple: true
      }, {
        name: 'Scratch < 30cm',
        prices: {
          SIMPLE: 5,
          COMPLEX: 9
        },
        id: '13.haut-ret-div-11'
      }, {
        name: 'Scratch > 30cm',
        prices: {
          SIMPLE: 7,
          COMPLEX: 11
        },
        id: '13.haut-ret-div-12'
      }, {
        name: 'Crochets (x1) : ajout / retrait',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '13.haut-ret-div-13',
        multiple: true
      }, {
        name: 'Bretelles (x2) : ajout / retrait',
        prices: {
          SIMPLE: 12,
          COMPLEX: 18
        },
        id: '13.haut-ret-div-14'
      }, {
        name: 'Épaulettes (x2) : ajout / retrait',
        prices: {
          SIMPLE: 18,
          COMPLEX: 21
        },
        liningPrices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        id: '13.haut-ret-div-15'
      }, {
        name: 'Oeillet petit (x1) : ajout',
        prices: {
          SIMPLE: 1,
          COMPLEX: 1
        },
        multiple: true,
        id: '13.haut-ret-div-16'
      }, {
        name: 'Couture de finition simple',
        prices: {
          SIMPLE: 4,
          COMPLEX: 6
        },
        multiple: true,
        id: '13.haut-ret-div-17',
        mostCommonCategoryPosition: 6,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition complexe',
        prices: {
          SIMPLE: 10,
          COMPLEX: 12
        },
        multiple: true,
        id: '13.haut-ret-div-18',
        mostCommonCategoryPosition: 7,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition avec empiècement',
        prices: {
          SIMPLE: 15,
          COMPLEX: 19
        },
        multiple: true,
        id: '13.haut-ret-div-19',
        mostCommonCategoryPosition: 8,
        onlyCouturiers: true
      }, {
        name: '1h de conseil',
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        id: '13.haut-ret-div-20'
      }]
    }]
  }, {
    name: 'Réparer',
    slug: 'repair',
    subCategories: [(0, _commonPricings.getCommunTearRepair)({
      slug: 'haut',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunZipsRepair)({
      slug: 'haut',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunButtonsRepair)({
      slug: 'haut',
      isSuitableForJunior: true
    }), {
      name: 'Plus de réparations',
      slug: 'more_repair',
      items: [{
        name: 'Doublure : réparation / remplacement',
        prices: {
          SIMPLE: 35,
          COMPLEX: 60
        },
        id: '13.haut-rep-div-1',
        repairBonus: {
          SIMPLE: 'LINING_SIMPLE',
          COMPLEX: 'LINING_COMPLEX'
        }
      }, {
        name: 'Doublure - Sac de poche : réparation / remplacement',
        prices: {
          SIMPLE: 17,
          COMPLEX: 19
        },
        id: '13.haut-rep-div-2',
        repairBonus: {
          SIMPLE: 'LINING_SIMPLE',
          COMPLEX: 'LINING_COMPLEX'
        }
      }, {
        name: 'Scratch < 30cm : réparation / remplacement',
        prices: {
          SIMPLE: 5,
          COMPLEX: 9
        },
        id: '13.haut-rep-div-3'
      }, {
        name: 'Scratch > 30cm : réparation / remplacement',
        prices: {
          SIMPLE: 7,
          COMPLEX: 11
        },
        id: '13.haut-rep-div-4'
      }, {
        name: 'Crochets (x1) : réparation / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '13.haut-rep-div-5'
      }, {
        name: 'Coudière (x2)',
        prices: {
          SIMPLE: 17,
          COMPLEX: 20
        },
        id: '13.haut-rep-div-6',
        repairBonus: 'HOLE'
      }]
    }]
  }, {
    name: 'Broder',
    slug: 'embroidery',
    subCategories: [(0, _commonPricings.getEmbroideryPricingsCategory)('haut', undefined), (0, _commonPricings.getCommunMachineEmbroidery)({
      slug: 'haut'
    })]
  }]
}, {
  name: 'Pantalon',
  slug: 'pant',
  hasMostCommonCategory: true,
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Habillé'
  }],
  categories: [{
    name: 'Retoucher',
    slug: 'alteration',
    subCategories: [{
      name: 'Cintrer',
      slug: 'cin_alteration',
      items: [{
        name: 'Ceinture',
        prices: {
          SIMPLE: 42,
          COMPLEX: 44
        },
        id: '13.pant-ret-cin-1'
      }, {
        name: 'Jambes (x2)',
        prices: {
          SIMPLE: 42,
          COMPLEX: 45
        },
        id: '13.pant-ret-cin-2'
      }, {
        name: 'Bas de jambes (x2)',
        prices: {
          SIMPLE: 28,
          COMPLEX: 30
        },
        id: '13.pant-ret-cin-3',
        mostCommonCategoryPosition: 5,
        mostCommonCategoryLabel: 'Cintrer bas de jambes'
      }, {
        name: 'Entrejambe',
        prices: {
          SIMPLE: 18,
          COMPLEX: 20
        },
        id: '13.pant-ret-cin-4',
        potentialFabrics: ['suit_intermediate']
      }]
    }, {
      name: 'Élargir',
      slug: 'ela_alteration',
      items: [{
        name: 'Ceinture',
        prices: {
          SIMPLE: 47,
          COMPLEX: 47
        },
        id: '13.pant-ret-ela-1'
      }, {
        name: 'Jambes (x2)',
        prices: {
          SIMPLE: 47,
          COMPLEX: 50
        },
        id: '13.pant-ret-ela-2'
      }, {
        name: 'Bas de jambes (x2)',
        prices: {
          SIMPLE: 28,
          COMPLEX: 30
        },
        id: '13.pant-ret-ela-3'
      }, {
        name: 'Entrejambe',
        prices: {
          SIMPLE: 20,
          COMPLEX: 27
        },
        id: '13.pant-ret-ela-4',
        potentialFabrics: ['suit_intermediate']
      }]
    }, {
      name: 'Ourlets',
      slug: 'hem_alteration',
      items: [{
        name: 'Ourlet simple (x2)',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 12,
          COMPLEX: 17
        },
        id: '13.pant-ret-rac-1',
        mostCommonCategoryPosition: 1,
        infoPreview: [{
          label: 'Envers',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739374282/ItemsPreview/simple_hem_back_btubj9.png'
        }, {
          label: 'Endroit',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739374282/ItemsPreview/simple_hem_front_eb85kg.png'
        }]
      }, {
        name: 'Ourlet revers (x2)',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 15,
          COMPLEX: 20
        },
        id: '13.pant-ret-rac-2',
        infoPreview: [{
          label: 'Envers',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739374282/ItemsPreview/revers_hem_front_v0jb6m.png'
        }, {
          label: 'Endroit',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739374282/ItemsPreview/revers_hem_back_vrtlql.png'
        }]
      }, {
        name: 'Ourlet de jean simple',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 12,
          COMPLEX: 12
        },
        id: '13.pant-ret-rac-3'
      }, {
        name: 'Ourlet de jean complexe',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 16,
          COMPLEX: 16
        },
        id: '13.pant-ret-rac-4',
        infoPreview: [{
          label: 'Envers',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739374283/ItemsPreview/jean_hem_front_eg9fkr.png'
        }, {
          label: 'Endroit',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739374283/ItemsPreview/jean_hem_back_oegjvv.png'
        }]
      }, {
        name: 'Ourlet invisible',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 17,
          COMPLEX: 17
        },
        id: '13.pant-ret-rac-5',
        infoPreview: [{
          label: 'Envers',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739374282/ItemsPreview/invisible_hem_front_gts9zi.png'
        }, {
          label: 'Endroit',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739374283/ItemsPreview/invisible_hem_back_uzk3uf.png'
        }]
      }, {
        name: 'Ourlet fantaisie',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 20,
          COMPLEX: 24
        },
        isPrivate: true,
        id: '13.pant-ret-rac-6'
      }, {
        name: 'Ourlet avec bande de tissu rapportée',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 16,
          COMPLEX: 16
        },
        id: '13.pant-ret-rac-7'
      }, {
        name: 'Ourlet avec patte / cordon / de serrage ',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 16,
          COMPLEX: 16
        },
        id: '13.pant-ret-rac-8'
      }, {
        name: 'Ourlet sur jambe fuselée',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 16,
          COMPLEX: 16
        },
        id: '13.pant-ret-rac-9'
      }]
    }, {
      name: 'Rallonger',
      slug: 'ral_alteration',
      items: [{
        name: 'Jambes (x2)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 20
        },
        id: '13.pant-ret-ral-1'
      }, {
        name: 'Ourlet (x2) : suppression des revers',
        prices: {
          SIMPLE: 15,
          COMPLEX: 17
        },
        id: '13.pant-ret-ral-2'
      }]
    }, (0, _commonPricings.getCommunZipsAlteration)({
      slug: 'pant',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunButtonsAlteration)({
      slug: 'pant',
      isSuitableForJunior: true
    }), {
      name: 'Plus de retouches',
      slug: 'more_alteration',
      items: [{
        name: 'Doublure : ajout / retrait',
        prices: {
          SIMPLE: 42,
          COMPLEX: 49
        },
        id: '13.pant-ret-div-1'
      }, {
        name: 'Genouillère (x2) : ajout / retrait',
        prices: {
          SIMPLE: 17,
          COMPLEX: 20
        },
        id: '13.pant-ret-div-2'
      }, {
        name: 'Passant (x1) : ajout / retrait',
        prices: {
          SIMPLE: 4,
          COMPLEX: 8
        },
        id: '13.pant-ret-div-3',
        multiple: true
      }, {
        name: 'Pince (x1) : ajout / retrait',
        prices: {
          SIMPLE: 8,
          COMPLEX: 12
        },
        id: '13.pant-ret-div-4',
        multiple: true
      }, {
        name: 'Fente : ajout / retrait',
        prices: {
          SIMPLE: 12,
          COMPLEX: 18
        },
        id: '13.pant-ret-div-5'
      }, {
        name: 'Élastique : ajout',
        prices: {
          SIMPLE: 7,
          COMPLEX: 17
        },
        id: '13.pant-ret-div-6'
      }, {
        name: 'Perlage (5 à 10 perles) : ajout / retrait',
        prices: {
          SIMPLE: 15,
          COMPLEX: 17
        },
        id: '13.pant-ret-div-7',
        multiple: true
      }, {
        name: 'Poche plate simple (x1) : ajout/retrait',
        prices: {
          SIMPLE: 10,
          COMPLEX: 15
        },
        id: '13.pant-ret-div-8',
        multiple: true
      }, {
        name: 'Poche classique (x1) : ajout',
        prices: {
          SIMPLE: 15,
          COMPLEX: 19
        },
        id: '13.pant-ret-div-9',
        multiple: true
      }, {
        name: 'Poche complexe (x1) : ajout',
        prices: {
          SIMPLE: 20,
          COMPLEX: 22
        },
        id: '13.pant-ret-div-10',
        multiple: true
      }, {
        name: 'Scratch < 30cm',
        prices: {
          SIMPLE: 5,
          COMPLEX: 9
        },
        id: '13.pant-ret-div-11'
      }, {
        name: 'Scratch > 30cm',
        prices: {
          SIMPLE: 7,
          COMPLEX: 11
        },
        id: '13.pant-ret-div-12'
      }, {
        name: 'Crochets (x1) : ajout / retrait',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '13.pant-ret-div-13',
        multiple: true
      }, {
        name: 'Couture de finition simple',
        prices: {
          SIMPLE: 4,
          COMPLEX: 6
        },
        multiple: true,
        id: '13.pant-ret-div-14',
        mostCommonCategoryPosition: 6,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition complexe',
        prices: {
          SIMPLE: 10,
          COMPLEX: 12
        },
        multiple: true,
        id: '13.pant-ret-div-15',
        mostCommonCategoryPosition: 7,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition avec empiècement',
        prices: {
          SIMPLE: 15,
          COMPLEX: 19
        },
        multiple: true,
        id: '13.pant-ret-div-16',
        mostCommonCategoryPosition: 8,
        onlyCouturiers: true
      }, {
        name: '1h de conseil',
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        id: '13.pant-ret-div-17'
      }]
    }]
  }, {
    name: 'Réparer',
    slug: 'repair',
    subCategories: [(0, _commonPricings.getCommunTearRepair)({
      slug: 'pant',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunZipsRepair)({
      slug: 'pant',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunButtonsRepair)({
      slug: 'pant',
      isSuitableForJunior: true
    }), {
      name: 'Plus de réparations',
      slug: 'more_repair',
      items: [{
        name: 'Doublure : réparation / remplacement',
        prices: {
          SIMPLE: 25,
          COMPLEX: 35
        },
        id: '13.pant-rep-div-1',
        repairBonus: {
          SIMPLE: 'LINING_SIMPLE',
          COMPLEX: 'LINING_COMPLEX'
        }
      }, {
        name: 'Doublure - Sac de poche : réparation / remplacement',
        prices: {
          SIMPLE: 17,
          COMPLEX: 19
        },
        id: '13.pant-rep-div-2',
        repairBonus: {
          SIMPLE: 'LINING_SIMPLE',
          COMPLEX: 'LINING_COMPLEX'
        }
      }, {
        name: 'Scratch < 30cm : réparation / remplacement',
        prices: {
          SIMPLE: 5,
          COMPLEX: 9
        },
        id: '13.pant-rep-div-3'
      }, {
        name: 'Scratch > 30cm : réparation / remplacement',
        prices: {
          SIMPLE: 7,
          COMPLEX: 11
        },
        id: '13.pant-rep-div-4'
      }, {
        name: 'Crochets (x1) : réparation / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '13.pant-rep-div-5'
      }, {
        name: 'Genouillère (x2) : réparation / remplacement',
        prices: {
          SIMPLE: 17,
          COMPLEX: 20
        },
        id: '13.pant-rep-div-6',
        repairBonus: 'HOLE'
      }, {
        name: 'Ourlet - décousu (x2 jambes)',
        prices: {
          SIMPLE: 12,
          COMPLEX: 14
        },
        id: '13.pant-rep-div-7',
        repairBonus: 'UNTIED_UNLINED'
      }]
    }]
  }, {
    name: 'Broder',
    slug: 'embroidery',
    subCategories: [(0, _commonPricings.getEmbroideryPricingsCategory)('pant', undefined), (0, _commonPricings.getCommunMachineEmbroidery)({
      slug: 'pant'
    })]
  }]
}, {
  name: 'Jupe',
  slug: 'jupe',
  hasMostCommonCategory: true,
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Habillée'
  }],
  categories: [{
    name: 'Retoucher',
    slug: 'alteration',
    subCategories: [{
      name: 'Cintrer',
      slug: 'cin_alteration',
      items: [{
        name: 'Taille / ceinture',
        prices: {
          SIMPLE: 27,
          COMPLEX: 33
        },
        liningPrices: {
          SIMPLE: 3,
          COMPLEX: 5
        },
        id: '13.jupe-ret-cin-1',
        mostCommonCategoryPosition: 5
      }, {
        name: 'Côtés (x2)',
        prices: {
          SIMPLE: 20,
          COMPLEX: 23
        },
        liningPrices: {
          SIMPLE: 4,
          COMPLEX: 5
        },
        id: '13.jupe-ret-cin-2'
      }]
    }, {
      name: 'Élargir',
      slug: 'ela_alteration',
      items: [{
        name: 'Côtés (x2)',
        prices: {
          SIMPLE: 22,
          COMPLEX: 25
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 6
        },
        id: '13.jupe-ret-ela-1'
      }, {
        name: 'Taille / ceinture',
        prices: {
          SIMPLE: 29,
          COMPLEX: 35
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 6
        },
        id: '13.jupe-ret-ela-2'
      }]
    }, {
      name: 'Raccourcir',
      slug: 'rac_alteration',
      items: [{
        name: 'Ourlet simple',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 12,
          COMPLEX: 20
        },
        liningPrices: {
          SIMPLE: 4,
          COMPLEX: 4
        },
        id: '13.jupe-ret-rac-1',
        mostCommonCategoryPosition: 1
      }, {
        name: 'Ourlet invisible',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        liningPrices: {
          SIMPLE: 4,
          COMPLEX: 4
        },
        id: '13.jupe-ret-rac-7',
        infoPreview: [{
          label: 'Exemple',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739358653/ItemsPreview/invisible_skirt_hem_qd2ibh.png'
        }]
      }, {
        name: 'Ourlet ample',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 18,
          COMPLEX: 23
        },
        liningPrices: {
          SIMPLE: 4,
          COMPLEX: 5
        },
        id: '13.jupe-ret-rac-2'
      }, {
        name: 'Ourlet à volants',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 22,
          COMPLEX: 28
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 6
        },
        id: '13.jupe-ret-rac-3',
        infoPreview: [{
          label: 'Exemple',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739358747/ItemsPreview/flying_skirt_hem_petkid.png'
        }]
      }, {
        name: 'Ourlet fantaisie',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 22,
          COMPLEX: 28
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 6
        },
        isPrivate: true,
        id: '13.jupe-ret-rac-4'
      }, {
        name: 'Ourlet avec bande de tissu rapportée',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 18,
          COMPLEX: 18
        },
        id: '13.jupe-ret-rac-9'
      }]
    }, {
      name: 'Rallonger',
      slug: 'ral_alteration',
      items: [{
        name: 'Longueur simple',
        prices: {
          SIMPLE: 15,
          COMPLEX: 20
        },
        liningPrices: {
          SIMPLE: 4,
          COMPLEX: 4
        },
        id: '13.jupe-ret-ral-1'
      }, {
        name: 'Longueur ample',
        prices: {
          SIMPLE: 20,
          COMPLEX: 23
        },
        liningPrices: {
          SIMPLE: 4,
          COMPLEX: 5
        },
        id: '13.jupe-ret-ral-2'
      }, {
        name: 'Longueur à volants',
        prices: {
          SIMPLE: 22,
          COMPLEX: 30
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '13.jupe-ret-ral-3'
      }]
    }, (0, _commonPricings.getCommunZipsAlteration)({
      slug: 'jupe',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunButtonsAlteration)({
      slug: 'jupe',
      isSuitableForJunior: true
    }), {
      name: 'Plus de retouches',
      slug: 'more_alteration',
      items: [{
        name: 'Doublure : ajout / retrait',
        prices: {
          SIMPLE: 42,
          COMPLEX: 49
        },
        id: '13.jupe-ret-div-1'
      }, {
        name: 'Passant (x1) : ajout / retrait',
        prices: {
          SIMPLE: 4,
          COMPLEX: 8
        },
        id: '13.jupe-ret-div-3',
        multiple: true
      }, {
        name: 'Pince (x1) : ajout',
        prices: {
          SIMPLE: 8,
          COMPLEX: 12
        },
        id: '13.jupe-ret-div-4',
        multiple: true
      }, {
        name: 'Fente : ajout / retrait',
        prices: {
          SIMPLE: 12,
          COMPLEX: 18
        },
        id: '13.jupe-ret-div-5'
      }, {
        name: 'Élastique : ajout',
        prices: {
          SIMPLE: 7,
          COMPLEX: 17
        },
        id: '13.jupe-ret-div-6'
      }, {
        name: 'Perlage (5 à 10 perles)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 17
        },
        id: '13.jupe-ret-div-7',
        multiple: true
      }, {
        name: 'Poche plate simple (x1) : ajout/retrait ',
        prices: {
          SIMPLE: 10,
          COMPLEX: 15
        },
        id: '13.jupe-ret-div-8',
        multiple: true
      }, {
        name: 'Poche intérieure classique (x1) : ajout',
        prices: {
          SIMPLE: 15,
          COMPLEX: 19
        },
        id: '13.jupe-ret-div-9',
        multiple: true
      }, {
        name: 'Poche complexe (x1) : ajout',
        prices: {
          SIMPLE: 20,
          COMPLEX: 22
        },
        id: '13.jupe-ret-div-10',
        multiple: true
      }, {
        name: 'Scratch < 30cm',
        prices: {
          SIMPLE: 5,
          COMPLEX: 9
        },
        id: '13.jupe-ret-div-11'
      }, {
        name: 'Scratch > 30cm',
        prices: {
          SIMPLE: 7,
          COMPLEX: 11
        },
        id: '13.jupe-ret-div-12'
      }, {
        name: 'Crochets (x1) : ajout / retrait',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '13.jupe-ret-div-13',
        multiple: true
      }, {
        name: 'Bretelles (x2) : ajout / retrait',
        prices: {
          SIMPLE: 12,
          COMPLEX: 18
        },
        id: '13.jupe-ret-div-14'
      }, {
        name: 'Oeillet petit (x1) : ajout',
        prices: {
          SIMPLE: 1,
          COMPLEX: 1
        },
        multiple: true,
        id: '13.jupe-ret-div-15'
      }, {
        name: 'Couture de finition simple',
        prices: {
          SIMPLE: 4,
          COMPLEX: 6
        },
        multiple: true,
        id: '13.jupe-ret-div-16',
        mostCommonCategoryPosition: 6,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition complexe',
        prices: {
          SIMPLE: 10,
          COMPLEX: 12
        },
        multiple: true,
        id: '13.jupe-ret-div-17',
        mostCommonCategoryPosition: 7,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition avec empiècement',
        prices: {
          SIMPLE: 15,
          COMPLEX: 19
        },
        multiple: true,
        id: '13.jupe-ret-div-18',
        mostCommonCategoryPosition: 8,
        onlyCouturiers: true
      }, {
        name: '1h de conseil',
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        id: '13.jupe-ret-div-19'
      }]
    }]
  }, {
    name: 'Réparer',
    slug: 'repair',
    subCategories: [(0, _commonPricings.getCommunTearRepair)({
      slug: 'jupe',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunZipsRepair)({
      slug: 'jupe',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunButtonsRepair)({
      slug: 'jupe',
      isSuitableForJunior: true
    }), {
      name: 'Plus de réparations',
      slug: 'more_repair',
      items: [{
        name: 'Doublure : réparation / remplacement',
        prices: {
          SIMPLE: 35,
          COMPLEX: 60
        },
        id: '13.jupe-rep-div-1',
        repairBonus: {
          SIMPLE: 'LINING_SIMPLE',
          COMPLEX: 'LINING_COMPLEX'
        }
      }, {
        name: 'Doublure - sac de poche : réparation / remplacement',
        prices: {
          SIMPLE: 17,
          COMPLEX: 19
        },
        id: '13.jupe-rep-div-2',
        repairBonus: 'LINING_SIMPLE'
      }, {
        name: 'Scratch < 30cm : réparation / remplacement',
        prices: {
          SIMPLE: 5,
          COMPLEX: 9
        },
        id: '13.jupe-rep-div-3'
      }, {
        name: 'Scratch > 30cm : réparation / remplacement',
        prices: {
          SIMPLE: 7,
          COMPLEX: 11
        },
        id: '13.jupe-rep-div-4'
      }, {
        name: 'Crochets (x1) : réparation / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '13.jupe-rep-div-5'
      }, {
        name: 'Ourlet - décousu',
        prices: {
          SIMPLE: 12,
          COMPLEX: 14
        },
        id: '13.jupe-rep-div-6',
        repairBonus: 'UNTIED_UNLINED'
      }]
    }]
  }, {
    name: 'Broder',
    slug: 'embroidery',
    subCategories: [(0, _commonPricings.getEmbroideryPricingsCategory)('jupe', undefined)]
  }]
}, {
  name: 'Robe',
  slug: 'robe',
  hasMostCommonCategory: true,
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Habillée'
  }],
  categories: [{
    name: 'Retoucher',
    slug: 'alteration',
    subCategories: [{
      name: 'Cintrer',
      slug: 'cin_alteration',
      items: [{
        name: 'Côtés (x2)',
        prices: {
          SIMPLE: 20,
          COMPLEX: 23
        },
        liningPrices: {
          SIMPLE: 4,
          COMPLEX: 5
        },
        id: '13.robe-ret-cin-1'
      }, {
        name: 'Épaules (x2)',
        prices: {
          SIMPLE: 22,
          COMPLEX: 24
        },
        liningPrices: {
          SIMPLE: 3,
          COMPLEX: 4
        },
        id: '13.robe-ret-cin-2'
      }, {
        name: 'Manches (x2 - sans boutonnière)',
        prices: {
          SIMPLE: 20,
          COMPLEX: 27
        },
        id: '13.robe-ret-cin-3'
      }, {
        name: 'Manches (x2 - boutonnière)',
        prices: {
          SIMPLE: 32,
          COMPLEX: 34
        },
        id: '13.robe-ret-cin-4'
      }, {
        name: 'Bustier / taille',
        prices: {
          SIMPLE: 25,
          COMPLEX: 33
        },
        liningPrices: {
          SIMPLE: 3,
          COMPLEX: 5
        },
        id: '13.robe-ret-cin-5',
        mostCommonCategoryPosition: 5,
        mostCommonCategoryLabel: 'Cintrer taille'
      }, {
        name: 'Dos',
        prices: {
          SIMPLE: 21,
          COMPLEX: 24
        },
        liningPrices: {
          SIMPLE: 4,
          COMPLEX: 5
        },
        id: '13.robe-ret-cin-6'
      }]
    }, {
      name: 'Élargir',
      slug: 'ela_alteration',
      items: [{
        name: 'Côtés (x2)',
        prices: {
          SIMPLE: 23,
          COMPLEX: 26
        },
        liningPrices: {
          SIMPLE: 6,
          COMPLEX: 6
        },
        id: '13.robe-ret-ela-1'
      }, {
        name: 'Épaules (x2)',
        prices: {
          SIMPLE: 25,
          COMPLEX: 30
        },
        liningPrices: {
          SIMPLE: 4,
          COMPLEX: 5
        },
        id: '13.robe-ret-ela-2'
      }, {
        name: 'Manches (x2 - sans boutonnière)',
        prices: {
          SIMPLE: 25,
          COMPLEX: 29
        },
        id: '13.robe-ret-ela-3'
      }, {
        name: 'Manches (x2 - boutonnière)',
        prices: {
          SIMPLE: 35,
          COMPLEX: 38
        },
        id: '13.robe-ret-ela-4'
      }, {
        name: 'Bustier / taille',
        prices: {
          SIMPLE: 27,
          COMPLEX: 35
        },
        liningPrices: {
          SIMPLE: 3,
          COMPLEX: 5
        },
        id: '13.robe-ret-ela-5'
      }, {
        name: 'Dos',
        prices: {
          SIMPLE: 26,
          COMPLEX: 27
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 6
        },
        id: '13.robe-ret-ela-6'
      }]
    }, {
      name: 'Raccourcir',
      slug: 'rac_alteration',
      items: [{
        name: 'Ourlet simple',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 12,
          COMPLEX: 20
        },
        liningPrices: {
          SIMPLE: 4,
          COMPLEX: 4
        },
        id: '13.robe-ret-rac-1',
        mostCommonCategoryPosition: 1
      }, {
        name: 'Ourlet invisible',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        liningPrices: {
          SIMPLE: 4,
          COMPLEX: 4
        },
        id: '13.robe-ret-rac-7'
      }, {
        name: 'Ourlet ample',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 18,
          COMPLEX: 23
        },
        liningPrices: {
          SIMPLE: 4,
          COMPLEX: 5
        },
        id: '13.robe-ret-rac-2'
      }, {
        name: 'Ourlet à volants',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 22,
          COMPLEX: 28
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 6
        },
        id: '13.robe-ret-rac-3'
      }, {
        name: 'Manches (x2 - sans boutonnière)',
        prices: {
          SIMPLE: 12,
          COMPLEX: 16
        },
        id: '13.robe-ret-rac-4'
      }, {
        name: 'Manches (x2 - boutonnière)',
        prices: {
          SIMPLE: 22,
          COMPLEX: 26
        },
        id: '13.robe-ret-rac-5'
      }, {
        name: 'Bretelles (x2)',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 8,
          COMPLEX: 18
        },
        id: '13.robe-ret-rac-6'
      }, {
        name: 'Ourlet fantaisie',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 22,
          COMPLEX: 28
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 6
        },
        isPrivate: true,
        id: '13.robe-ret-rac-8'
      }, {
        name: 'Ourlet avec bande de tissu rapportée',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 18,
          COMPLEX: 18
        },
        id: '13.robe-ret-rac-9'
      }]
    }, {
      name: 'Rallonger',
      slug: 'ral_alteration',
      items: [{
        name: 'Longueur simple',
        prices: {
          SIMPLE: 15,
          COMPLEX: 20
        },
        liningPrices: {
          SIMPLE: 4,
          COMPLEX: 4
        },
        id: '13.robe-ret-ral-1'
      }, {
        name: 'Longueur ample',
        prices: {
          SIMPLE: 20,
          COMPLEX: 23
        },
        liningPrices: {
          SIMPLE: 4,
          COMPLEX: 5
        },
        id: '13.robe-ret-ral-2'
      }, {
        name: 'Longueur à volants',
        prices: {
          SIMPLE: 22,
          COMPLEX: 30
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '13.robe-ret-ral-3'
      }, {
        name: 'Manches (x2 - sans boutonnière)',
        prices: {
          SIMPLE: 14,
          COMPLEX: 17
        },
        id: '13.robe-ret-ral-4'
      }, {
        name: 'Manches (x2 - boutonnière)',
        prices: {
          SIMPLE: 25,
          COMPLEX: 28
        },
        id: '13.robe-ret-ral-5'
      }, {
        name: 'Bretelles (x2)',
        prices: {
          SIMPLE: 12,
          COMPLEX: 20
        },
        id: '13.robe-ret-ral-6'
      }]
    }, (0, _commonPricings.getCommunZipsAlteration)({
      slug: 'robe',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunButtonsAlteration)({
      slug: 'robe',
      isSuitableForJunior: true
    }), {
      name: 'Plus de retouches',
      slug: 'more_alteration',
      items: [{
        name: 'Doublure : ajout / retrait',
        prices: {
          SIMPLE: 42,
          COMPLEX: 49
        },
        id: '13.robe-ret-div-1'
      }, {
        name: 'Passant (x1) : ajout / retrait',
        prices: {
          SIMPLE: 4,
          COMPLEX: 8
        },
        id: '13.robe-ret-div-3',
        multiple: true
      }, {
        name: 'Pince (x1) : ajout',
        prices: {
          SIMPLE: 8,
          COMPLEX: 12
        },
        id: '13.robe-ret-div-4',
        multiple: true
      }, {
        name: 'Fente : ajout / retrait',
        prices: {
          SIMPLE: 12,
          COMPLEX: 18
        },
        id: '13.robe-ret-div-5'
      }, {
        name: 'Élastique : ajout',
        prices: {
          SIMPLE: 7,
          COMPLEX: 17
        },
        id: '13.robe-ret-div-6'
      }, {
        name: 'Perlage (5 à 10 perles)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 17
        },
        id: '13.robe-ret-div-7',
        multiple: true
      }, {
        name: 'Poche plate simple (x1) : ajout/retrait',
        prices: {
          SIMPLE: 10,
          COMPLEX: 15
        },
        id: '13.robe-ret-div-8',
        multiple: true
      }, {
        name: 'Poche intérieure classique (x1) : ajout',
        prices: {
          SIMPLE: 15,
          COMPLEX: 19
        },
        id: '13.robe-ret-div-9',
        multiple: true
      }, {
        name: 'Poche complexe (x1) : ajout',
        prices: {
          SIMPLE: 20,
          COMPLEX: 22
        },
        id: '13.robe-ret-div-10',
        multiple: true
      }, {
        name: 'Scratch < 30cm',
        prices: {
          SIMPLE: 5,
          COMPLEX: 9
        },
        id: '13.robe-ret-div-11'
      }, {
        name: 'Scratch > 30cm',
        prices: {
          SIMPLE: 7,
          COMPLEX: 11
        },
        id: '13.robe-ret-div-12'
      }, {
        name: 'Crochets (x1) : ajout / retrait',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '13.robe-ret-div-13',
        multiple: true
      }, {
        name: 'Bretelles (x2) : ajout / retrait',
        prices: {
          SIMPLE: 12,
          COMPLEX: 18
        },
        id: '13.robe-ret-div-14'
      }, {
        name: 'Épaulettes (x2) : ajout / retrait',
        prices: {
          SIMPLE: 18,
          COMPLEX: 21
        },
        liningPrices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        id: '13.robe-ret-div-15'
      }, {
        name: 'Oeillet petit (x1) : ajout',
        prices: {
          SIMPLE: 1,
          COMPLEX: 1
        },
        multiple: true,
        id: '13.robe-ret-div-16'
      }, {
        name: 'Couture de finition simple',
        prices: {
          SIMPLE: 4,
          COMPLEX: 6
        },
        multiple: true,
        id: '13.robe-ret-div-17',
        mostCommonCategoryPosition: 6,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition complexe',
        prices: {
          SIMPLE: 10,
          COMPLEX: 12
        },
        multiple: true,
        id: '13.robe-ret-div-18',
        mostCommonCategoryPosition: 7,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition avec empiècement',
        prices: {
          SIMPLE: 15,
          COMPLEX: 19
        },
        multiple: true,
        id: '13.robe-ret-div-19',
        mostCommonCategoryPosition: 8,
        onlyCouturiers: true
      }, {
        name: '1h de conseil',
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        id: '13.robe-ret-div-20'
      }]
    }]
  }, {
    name: 'Réparer',
    slug: 'repair',
    subCategories: [(0, _commonPricings.getCommunTearRepair)({
      slug: 'robe',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunZipsRepair)({
      slug: 'robe',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunButtonsRepair)({
      slug: 'robe',
      isSuitableForJunior: true
    }), {
      name: 'Plus de réparations',
      slug: 'more_repair',
      items: [{
        name: 'Doublure : réparation / remplacement',
        prices: {
          SIMPLE: 35,
          COMPLEX: 60
        },
        id: '13.robe-rep-div-1',
        repairBonus: {
          SIMPLE: 'LINING_SIMPLE',
          COMPLEX: 'LINING_COMPLEX'
        }
      }, {
        name: 'Doublure - sac de poche : réparation / remplacement',
        prices: {
          SIMPLE: 17,
          COMPLEX: 19
        },
        id: '13.robe-rep-div-2',
        repairBonus: 'LINING_SIMPLE'
      }, {
        name: 'Scratch < 30cm : réparation / remplacement',
        prices: {
          SIMPLE: 5,
          COMPLEX: 9
        },
        id: '13.robe-rep-div-3'
      }, {
        name: 'Scratch > 30cm : réparation / remplacement',
        prices: {
          SIMPLE: 7,
          COMPLEX: 11
        },
        id: '13.robe-rep-div-4'
      }, {
        name: 'Crochets (x1) : réparation / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '13.robe-rep-div-5'
      }, {
        name: 'Ourlet - décousu',
        prices: {
          SIMPLE: 12,
          COMPLEX: 14
        },
        id: '13.robe-rep-div-6',
        repairBonus: 'UNTIED_UNLINED'
      }, {
        name: 'Coudière (x2)',
        prices: {
          SIMPLE: 17,
          COMPLEX: 20
        },
        id: '13.robe-rep-div-7',
        repairBonus: 'HOLE'
      }, {
        name: 'Passant (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 4,
          COMPLEX: 8
        },
        isPrivate: true,
        id: '13.robe-rep-div-8'
      }]
    }]
  }, {
    name: 'Broder',
    slug: 'embroidery',
    subCategories: [(0, _commonPricings.getEmbroideryPricingsCategory)('robe', undefined)]
  }]
}, {
  name: 'Pull & gilet',
  slug: 'pull',
  hasMostCommonCategory: true,
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Laine & cachemire'
  }],
  categories: [{
    name: 'Retoucher',
    slug: 'alteration',
    subCategories: [{
      name: 'Cintrer',
      slug: 'cin_alteration',
      items: [{
        name: 'Côtés (x2)',
        prices: {
          SIMPLE: 16,
          COMPLEX: 40
        },
        id: '13.pull-ret-cin-1'
      }, {
        name: 'Épaules (x2)',
        prices: {
          SIMPLE: 18,
          COMPLEX: 45
        },
        id: '13.pull-ret-cin-2'
      }, {
        name: 'Manches (x2 - sans boutonnière)',
        prices: {
          SIMPLE: 21,
          COMPLEX: 52
        },
        id: '13.pull-ret-cin-3'
      }, {
        name: 'Taille',
        prices: {
          SIMPLE: 18,
          COMPLEX: 45
        },
        id: '13.pull-ret-cin-4'
      }, {
        name: 'Dos',
        prices: {
          SIMPLE: 11,
          COMPLEX: 27
        },
        id: '13.pull-ret-cin-5',
        mostCommonCategoryPosition: 5,
        mostCommonCategoryLabel: 'Cintrer dos'
      }]
    }, {
      name: 'Élargir',
      slug: 'ela_alteration',
      items: [{
        name: 'Côtés (x2)',
        prices: {
          SIMPLE: 17,
          COMPLEX: 42
        },
        id: '13.pull-ret-ela-1'
      }, {
        name: 'Épaules (x2)',
        prices: {
          SIMPLE: 19,
          COMPLEX: 47
        },
        id: '13.pull-ret-ela-2'
      }, {
        name: 'Manches (x2 - sans boutonnière)',
        prices: {
          SIMPLE: 24,
          COMPLEX: 60
        },
        id: '13.pull-ret-ela-3'
      }, {
        name: 'Taille',
        prices: {
          SIMPLE: 20,
          COMPLEX: 50
        },
        id: '13.pull-ret-ela-4'
      }, {
        name: 'Dos',
        prices: {
          SIMPLE: 13,
          COMPLEX: 32
        },
        id: '13.pull-ret-ela-5'
      }]
    }, {
      name: 'Raccourcir',
      slug: 'rac_alteration',
      items: [{
        name: 'Longueur',
        prices: {
          SIMPLE: 14,
          COMPLEX: 35
        },
        id: '13.pull-ret-rac-1'
      }, {
        name: 'Manches (x2 - par le bas)',
        infoPreview: [{
          label: 'Exemple',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739363992/ItemsPreview/low_sleeve_klmxrr.png'
        }],
        prices: {
          SIMPLE: 12,
          COMPLEX: 30
        },
        id: '13.pull-ret-rac-2'
      }, {
        name: 'Manches (x2 - par l’épaule)',
        infoPreview: [{
          label: 'Exemple',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739363992/ItemsPreview/low_sleeve_klmxrr.png'
        }],
        prices: {
          SIMPLE: 37,
          COMPLEX: 92
        },
        id: '13.pull-ret-rac-3'
      }]
    }, {
      name: 'Rallonger',
      slug: 'ral_alteration',
      items: [{
        name: 'Longueur',
        prices: {
          SIMPLE: 17,
          COMPLEX: 42
        },
        id: '13.pull-ret-ral-1'
      }, {
        name: 'Manches (x2 - par le bas)',
        infoPreview: [{
          label: 'Exemple',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739363992/ItemsPreview/low_sleeve_klmxrr.png'
        }],
        prices: {
          SIMPLE: 12,
          COMPLEX: 30
        },
        id: '13.pull-ret-ral-2'
      }, {
        name: 'Manches (x2 - par l’épaule)',
        infoPreview: [{
          label: 'Exemple',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739363992/ItemsPreview/low_sleeve_klmxrr.png'
        }],
        prices: {
          SIMPLE: 37,
          COMPLEX: 92
        },
        id: '13.pull-ret-ral-3'
      }]
    }, (0, _commonPricings.getCommunZipsAlteration)({
      slug: 'pull',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunButtonsAlteration)({
      slug: 'pull',
      isSuitableForJunior: true
    }), {
      name: 'Plus de retouches',
      slug: 'more_alteration',
      items: [{
        name: 'Doublure : ajout / retrait',
        prices: {
          SIMPLE: 35,
          COMPLEX: 55
        },
        id: '13.pull-ret-div-1'
      }, {
        name: 'Passant (x1) : ajout / retrait',
        prices: {
          SIMPLE: 4,
          COMPLEX: 8
        },
        id: '13.pull-ret-div-3',
        multiple: true
      }, {
        name: 'Pince (x1) : ajout',
        prices: {
          SIMPLE: 8,
          COMPLEX: 12
        },
        id: '13.pull-ret-div-4',
        multiple: true
      }, {
        name: 'Fente : ajout / retrait',
        prices: {
          SIMPLE: 12,
          COMPLEX: 18
        },
        id: '13.pull-ret-div-5'
      }, {
        name: 'Élastique : ajout',
        prices: {
          SIMPLE: 7,
          COMPLEX: 17
        },
        id: '13.pull-ret-div-6'
      }, {
        name: 'Perlage (5 à 10 perles)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 17
        },
        id: '13.pull-ret-div-7',
        multiple: true
      }, {
        name: 'Poche plate simple (x1) : ajout/retrait',
        prices: {
          SIMPLE: 10,
          COMPLEX: 15
        },
        id: '13.pull-ret-div-8',
        multiple: true
      }, {
        name: 'Poche intérieure classique (x1) : ajout',
        prices: {
          SIMPLE: 15,
          COMPLEX: 19
        },
        id: '13.pull-ret-div-9',
        multiple: true
      }, {
        name: 'Poche complexe (x1) : ajout',
        prices: {
          SIMPLE: 20,
          COMPLEX: 22
        },
        id: '13.pull-ret-div-10',
        multiple: true
      }, {
        name: 'Scratch < 30cm',
        prices: {
          SIMPLE: 5,
          COMPLEX: 9
        },
        id: '13.pull-ret-div-11'
      }, {
        name: 'Scratch > 30cm',
        prices: {
          SIMPLE: 7,
          COMPLEX: 11
        },
        id: '13.pull-ret-div-12'
      }, {
        name: 'Crochets (x1) : ajout / retrait',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '13.pull-ret-div-13',
        multiple: true
      }, {
        name: 'Épaulettes (x2) : ajout / retrait',
        prices: {
          SIMPLE: 18,
          COMPLEX: 21
        },
        liningPrices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        id: '13.pull-ret-div-14'
      }, {
        name: 'Oeillet petit (x1) : ajout',
        prices: {
          SIMPLE: 1,
          COMPLEX: 1
        },
        multiple: true,
        id: '13.pull-ret-div-15'
      }, {
        name: 'Couture de finition simple',
        prices: {
          SIMPLE: 4,
          COMPLEX: 6
        },
        multiple: true,
        id: '13.pull-ret-div-16',
        mostCommonCategoryPosition: 6,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition complexe',
        prices: {
          SIMPLE: 10,
          COMPLEX: 12
        },
        multiple: true,
        id: '13.pull-ret-div-17',
        mostCommonCategoryPosition: 7,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition avec empiècement',
        prices: {
          SIMPLE: 15,
          COMPLEX: 19
        },
        multiple: true,
        id: '13.pull-ret-div-18',
        mostCommonCategoryPosition: 8,
        onlyCouturiers: true
      }, {
        name: '1h de conseil',
        prices: {
          SIMPLE: 30,
          COMPLEX: 30
        },
        id: '13.pull-ret-div-19'
      }, {
        name: 'Déboulochage',
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        id: '13.pull-ret-div-20'
      }, {
        name: 'Remplacement cordon de serrage sweatshirt (fourni par le client)',
        prices: {
          SIMPLE: 8,
          COMPLEX: 8
        },
        multiple: true,
        id: '13.pull-ret-div-21'
      }, {
        name: 'Remplacement cordon de serrage sweatshirt (fourni par Tilli)',
        prices: {
          SIMPLE: 10,
          COMPLEX: 10
        },
        multiple: true,
        id: '13.pull-ret-div-22'
      }]
    }]
  }, {
    name: 'Réparer',
    slug: 'repair',
    subCategories: [(0, _commonPricings.getCommunTearRepair)({
      slug: 'pull',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunZipsRepair)({
      slug: 'pull',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunButtonsRepair)({
      slug: 'pull',
      isSuitableForJunior: true
    }), {
      name: 'Plus de réparations',
      slug: 'more_repair',
      items: [{
        name: 'Doublure : réparation / remplacement',
        prices: {
          SIMPLE: 35,
          COMPLEX: 60
        },
        id: '13.pull-rep-div-1',
        repairBonus: {
          SIMPLE: 'LINING_SIMPLE',
          COMPLEX: 'LINING_COMPLEX'
        }
      }, {
        name: 'Doublure - Sac de poche : réparation / remplacement',
        prices: {
          SIMPLE: 17,
          COMPLEX: 19
        },
        id: '13.pull-rep-div-2',
        repairBonus: {
          SIMPLE: 'LINING_SIMPLE',
          COMPLEX: 'LINING_COMPLEX'
        }
      }, {
        name: 'Scratch < 30cm : réparation / remplacement',
        prices: {
          SIMPLE: 5,
          COMPLEX: 9
        },
        id: '13.pull-rep-div-3'
      }, {
        name: 'Scratch > 30cm : réparation / remplacement',
        prices: {
          SIMPLE: 7,
          COMPLEX: 11
        },
        id: '13.pull-rep-div-4'
      }, {
        name: 'Crochets (x1) : réparation / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '13.pull-rep-div-5'
      }, {
        name: 'Coudière (x2)',
        prices: {
          SIMPLE: 17,
          COMPLEX: 20
        },
        id: '13.pull-rep-div-6',
        repairBonus: 'HOLE'
      }]
    }]
  }, {
    name: 'Broder',
    slug: 'embroidery',
    subCategories: [(0, _commonPricings.getEmbroideryPricingsCategory)('pull', undefined)]
  }]
}, {
  name: 'Lingerie & maillot',
  slug: 'ling',
  hasMostCommonCategory: true,
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Lingerie fine'
  }],
  categories: [{
    name: 'Retoucher',
    slug: 'alteration',
    subCategories: [{
      name: 'Cintrer',
      slug: 'cin_alteration',
      items: [{
        name: 'Tour de poitrine',
        prices: {
          SIMPLE: 9,
          COMPLEX: 22
        },
        id: '13.ling-ret-cin-1'
      }, {
        name: 'Bonnets (x2)',
        prices: {
          SIMPLE: 12,
          COMPLEX: 30
        },
        liningPrices: {
          SIMPLE: 3,
          COMPLEX: 3
        },
        id: '13.ling-ret-cin-2'
      }, {
        name: 'Tour de taille',
        prices: {
          SIMPLE: 20,
          COMPLEX: 30
        },
        id: '13.ling-ret-cin-3'
      }]
    }, {
      name: 'Élargir',
      slug: 'ela_alteration',
      items: [{
        name: 'Tour de poitrine',
        prices: {
          SIMPLE: 10,
          COMPLEX: 25
        },
        id: '13.ling-ret-ela-1'
      }, {
        name: 'Tour de taille',
        prices: {
          SIMPLE: 20,
          COMPLEX: 40
        },
        id: '13.ling-ret-ela-2'
      }]
    }, {
      name: 'Raccourcir',
      slug: 'rac_alteration',
      items: [{
        name: 'Bretelles (x2)',
        prices: {
          SIMPLE: 8,
          COMPLEX: 20
        },
        id: '13.ling-ret-rac-1'
      }, {
        name: 'Forme culotte / caleçon',
        prices: {
          SIMPLE: 20,
          COMPLEX: 30
        },
        liningPrices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        id: '13.ling-ret-rac-2'
      }, {
        name: 'Ourlet',
        prices: {
          SIMPLE: 12
        },
        liningPrices: {
          SIMPLE: 2
        },
        id: '13.ling-ret-rac-3',
        mostCommonCategoryPosition: 5
      }]
    }, {
      name: 'Rallonger',
      slug: 'ral_alteration',
      items: [{
        name: 'Bretelles (x2)',
        prices: {
          SIMPLE: 9,
          COMPLEX: 22
        },
        id: '13.ling-ret-ral-1'
      }, {
        name: 'Forme culotte / caleçon',
        prices: {
          SIMPLE: 22,
          COMPLEX: 35
        },
        liningPrices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        id: '13.ling-ret-ral-2'
      }, {
        name: 'Longueur',
        prices: {
          SIMPLE: 14
        },
        liningPrices: {
          SIMPLE: 3
        },
        id: '13.ling-ret-ral-3'
      }]
    }, (0, _commonPricings.getCommunZipsAlteration)({
      slug: 'ling'
    }), (0, _commonPricings.getCommunButtonsAlteration)({
      slug: 'ling'
    }), {
      name: 'Plus de retouches',
      slug: 'more_alteration',
      items: [{
        name: 'Doublure : ajout / retrait',
        prices: {
          SIMPLE: 35,
          COMPLEX: 55
        },
        id: '13.ling-ret-div-1'
      }, {
        name: 'Passant (x1) : ajout / retrait',
        prices: {
          SIMPLE: 4,
          COMPLEX: 8
        },
        id: '13.ling-ret-div-3',
        multiple: true
      }, {
        name: 'Pince (x1) : ajout',
        prices: {
          SIMPLE: 8,
          COMPLEX: 12
        },
        id: '13.ling-ret-div-4',
        multiple: true
      }, {
        name: 'Fente : ajout / retrait',
        prices: {
          SIMPLE: 12,
          COMPLEX: 18
        },
        id: '13.ling-ret-div-5'
      }, {
        name: 'Élastique : ajout',
        prices: {
          SIMPLE: 7,
          COMPLEX: 17
        },
        id: '13.ling-ret-div-6',
        mostCommonCategoryPosition: 3
      }, {
        name: 'Perlage (5 à 10 perles)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 17
        },
        id: '13.ling-ret-div-7',
        multiple: true
      }, {
        name: 'Poche plate simple (x1) : ajout/retrait',
        prices: {
          SIMPLE: 10,
          COMPLEX: 15
        },
        id: '13.ling-ret-div-8',
        multiple: true
      }, {
        name: 'Poche intérieure classique (x1) : ajout',
        prices: {
          SIMPLE: 15,
          COMPLEX: 19
        },
        id: '13.ling-ret-div-9',
        multiple: true
      }, {
        name: 'Poche complexe (x1) : ajout',
        prices: {
          SIMPLE: 20,
          COMPLEX: 22
        },
        id: '13.ling-ret-div-10',
        multiple: true
      }, {
        name: 'Scratch < 30cm',
        prices: {
          SIMPLE: 5,
          COMPLEX: 9
        },
        id: '13.ling-ret-div-11'
      }, {
        name: 'Scratch > 30cm',
        prices: {
          SIMPLE: 7,
          COMPLEX: 11
        },
        id: '13.ling-ret-div-12'
      }, {
        name: 'Crochets (x1) : ajout / retrait',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '13.ling-ret-div-13',
        multiple: true
      }, {
        name: 'Bretelles (x2) : ajout / retrait',
        prices: {
          SIMPLE: 12,
          COMPLEX: 18
        },
        id: '13.ling-ret-div-14'
      }, {
        name: 'Attache dos : remplacement',
        prices: {
          SIMPLE: 10,
          COMPLEX: 15
        },
        multiple: true,
        id: '13.ling-ret-div-15'
      }, {
        name: 'Oeillet petit (x1) : ajout',
        prices: {
          SIMPLE: 1,
          COMPLEX: 1
        },
        multiple: true,
        id: '13.ling-ret-div-16'
      }, {
        name: 'Couture de finition simple',
        prices: {
          SIMPLE: 4,
          COMPLEX: 6
        },
        multiple: true,
        id: '13.ling-ret-div-17',
        mostCommonCategoryPosition: 6,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition complexe',
        prices: {
          SIMPLE: 10,
          COMPLEX: 12
        },
        multiple: true,
        id: '13.ling-ret-div-18',
        mostCommonCategoryPosition: 7,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition avec empiècement',
        prices: {
          SIMPLE: 15,
          COMPLEX: 19
        },
        multiple: true,
        id: '13.ling-ret-div-19',
        mostCommonCategoryPosition: 8,
        onlyCouturiers: true
      }, {
        name: '1h de conseil',
        prices: {
          SIMPLE: 30,
          COMPLEX: 30
        },
        id: '13.ling-ret-div-20'
      }]
    }]
  }, {
    name: 'Réparer',
    slug: 'repair',
    subCategories: [(0, _commonPricings.getCommunTearRepair)({
      slug: 'ling'
    }), (0, _commonPricings.getCommunZipsRepair)({
      slug: 'ling'
    }), (0, _commonPricings.getCommunButtonsRepair)({
      slug: 'ling'
    }), {
      name: 'Plus de réparations',
      slug: 'more_repair',
      items: [{
        name: 'Doublure : réparation / remplacement',
        prices: {
          SIMPLE: 35,
          COMPLEX: 60
        },
        id: '13.ling-rep-div-1'
      }, {
        name: 'Crochets (x1) : réparation / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '13.ling-rep-div-2'
      }, {
        name: 'Baleines (x2) : réparation / remplacement',
        prices: {
          SIMPLE: 12,
          COMPLEX: 17
        },
        liningPrices: {
          SIMPLE: 8,
          COMPLEX: 17
        },
        multiple: true,
        id: '13.ling-rep-div-3'
      }]
    }]
  }, {
    name: 'Broder',
    slug: 'embroidery',
    subCategories: [(0, _commonPricings.getEmbroideryPricingsCategory)('ling', undefined)]
  }]
}, {
  name: 'Combinaison',
  slug: 'comb',
  hasMostCommonCategory: true,
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Habillée'
  }],
  categories: [{
    name: 'Retoucher',
    slug: 'alteration',
    subCategories: [{
      name: 'Cintrer',
      slug: 'cin_alteration',
      items: [{
        name: 'Épaules (x2)',
        prices: {
          SIMPLE: 14.5,
          COMPLEX: 29
        },
        id: '13.comb-ret-cin-1'
      }, {
        name: 'Manches (x2)',
        prices: {
          SIMPLE: 14.5,
          COMPLEX: 29
        },
        id: '13.comb-ret-cin-2'
      }, {
        name: 'Taille',
        prices: {
          SIMPLE: 14.5,
          COMPLEX: 25
        },
        id: '13.comb-ret-cin-3'
      }, {
        name: 'Dos',
        prices: {
          SIMPLE: 9,
          COMPLEX: 18
        },
        id: '13.comb-ret-cin-4'
      }, {
        name: 'Ceinture',
        prices: {
          SIMPLE: 32,
          COMPLEX: 42
        },
        liningPrices: {
          COMPLEX: 11
        },
        id: '13.comb-ret-cin-5'
      }, {
        name: 'Jambes (x2)',
        prices: {
          SIMPLE: 42,
          COMPLEX: 45
        },
        liningPrices: {
          COMPLEX: 9
        },
        id: '13.comb-ret-cin-6'
      }, {
        name: 'Bas de jambes (x2)',
        prices: {
          SIMPLE: 22,
          COMPLEX: 24
        },
        liningPrices: {
          COMPLEX: 8
        },
        id: '13.comb-ret-cin-7',
        mostCommonCategoryPosition: 5,
        mostCommonCategoryLabel: 'Cintrer bas de jambes'
      }, {
        name: 'Entrejambe',
        prices: {
          SIMPLE: 15,
          COMPLEX: 22
        },
        liningPrices: {
          COMPLEX: 9
        },
        id: '13.comb-ret-cin-8'
      }]
    }, {
      name: 'Élargir',
      slug: 'ela_alteration',
      items: [{
        name: 'Épaules (x2)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 32
        },
        id: '13.comb-ret-ela-1'
      }, {
        name: 'Manches (x2)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 32
        },
        id: '13.comb-ret-ela-2'
      }, {
        name: 'Taille',
        prices: {
          SIMPLE: 15,
          COMPLEX: 28
        },
        id: '13.comb-ret-ela-3'
      }, {
        name: 'Dos',
        prices: {
          SIMPLE: 10,
          COMPLEX: 20
        },
        id: '13.comb-ret-ela-4'
      }, {
        name: 'Ceinture',
        prices: {
          SIMPLE: 38,
          COMPLEX: 47
        },
        liningPrices: {
          COMPLEX: 12
        },
        id: '13.comb-ret-ela-5'
      }, {
        name: 'Jambes (x2)',
        prices: {
          SIMPLE: 47,
          COMPLEX: 50
        },
        liningPrices: {
          COMPLEX: 10
        },
        id: '13.comb-ret-ela-6'
      }, {
        name: 'Bas de jambes (x2)',
        prices: {
          SIMPLE: 27,
          COMPLEX: 27
        },
        liningPrices: {
          COMPLEX: 9
        },
        id: '13.comb-ret-ela-7'
      }, {
        name: 'Entrejambe',
        prices: {
          SIMPLE: 20,
          COMPLEX: 27
        },
        liningPrices: {
          COMPLEX: 10
        },
        id: '13.comb-ret-ela-8'
      }]
    }, {
      name: 'Raccourcir',
      slug: 'rac_alteration',
      items: [{
        name: 'Manches (x2 - par le bas)',
        infoPreview: [{
          label: 'Exemple',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739363992/ItemsPreview/low_sleeve_klmxrr.png'
        }],
        prices: {
          SIMPLE: 10,
          COMPLEX: 23
        },
        id: '13.comb-ret-rac-1'
      }, {
        name: 'Manches (x2 - par l’épaule)',
        infoPreview: [{
          label: 'Exemple',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739363992/ItemsPreview/low_sleeve_klmxrr.png'
        }],
        prices: {
          SIMPLE: 28,
          COMPLEX: 65
        },
        id: '13.comb-ret-rac-2'
      }, {
        name: 'Bretelles (x2 - par l’épaule)',
        prices: {
          SIMPLE: 8,
          COMPLEX: 18
        },
        id: '13.comb-ret-rac-5'
      }, {
        name: 'Ourlet simple (x2)',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 12,
          COMPLEX: 17
        },
        liningPrices: {
          COMPLEX: 7
        },
        id: '13.comb-ret-rac-3',
        mostCommonCategoryPosition: 1,
        infoPreview: [{
          label: 'Envers',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739374282/ItemsPreview/simple_hem_back_btubj9.png'
        }, {
          label: 'Endroit',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739374282/ItemsPreview/simple_hem_front_eb85kg.png'
        }]
      }, {
        name: 'Ourlet revers (x2)',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 15,
          COMPLEX: 20
        },
        liningPrices: {
          COMPLEX: 9
        },
        id: '13.comb-ret-rac-4',
        infoPreview: [{
          label: 'Envers',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739374282/ItemsPreview/revers_hem_front_zqxq7y.png'
        }, {
          label: 'Endroit',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739374282/ItemsPreview/revers_hem_back_vrtlql.png'
        }]
      }, {
        name: 'Ourlet de jean simple',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 12,
          COMPLEX: 12
        },
        id: '13.comb-ret-rac-6'
      }, {
        name: 'Ourlet de jean complexe',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 16,
          COMPLEX: 16
        },
        id: '13.comb-ret-rac-7',
        infoPreview: [{
          label: 'Envers',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739374283/ItemsPreview/jean_hem_front_eg9fkr.png'
        }, {
          label: 'Endroit',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739374283/ItemsPreview/jean_hem_back_oegjvv.png'
        }]
      }, {
        name: 'Ourlet invisible',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 17,
          COMPLEX: 17
        },
        id: '13.comb-ret-rac-8',
        infoPreview: [{
          label: 'Envers',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739374282/ItemsPreview/invisible_hem_front_gts9zi.png'
        }, {
          label: 'Endroit',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739374283/ItemsPreview/invisible_hem_back_uzk3uf.png'
        }]
      }, {
        name: 'Ourlet fantaisie',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 20,
          COMPLEX: 24
        },
        isPrivate: true,
        id: '13.comb-ret-rac-9'
      }]
    }, {
      name: 'Rallonger',
      slug: 'ral_alteration',
      items: [{
        name: 'Manches (x2 - par le bas)',
        infoPreview: [{
          label: 'Exemple',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739363992/ItemsPreview/low_sleeve_klmxrr.png'
        }],
        prices: {
          SIMPLE: 12,
          COMPLEX: 27
        },
        id: '13.comb-ret-ral-1'
      }, {
        name: 'Manches (x2 - par l’épaule)',
        infoPreview: [{
          label: 'Exemple',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1739363992/ItemsPreview/low_sleeve_klmxrr.png'
        }],
        prices: {
          SIMPLE: 30,
          COMPLEX: 75
        },
        id: '13.comb-ret-ral-2'
      }, {
        name: 'Jambes (x2)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 20
        },
        liningPrices: {
          COMPLEX: 9
        },
        id: '13.comb-ret-ral-3'
      }]
    }, (0, _commonPricings.getCommunZipsAlteration)({
      slug: 'comb',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunButtonsAlteration)({
      slug: 'comb',
      isSuitableForJunior: true
    }), {
      name: 'Plus de retouches',
      slug: 'more_alteration',
      items: [{
        name: 'Doublure : ajout / retrait',
        prices: {
          SIMPLE: 35,
          COMPLEX: 55
        },
        id: '13.comb-ret-div-1'
      }, {
        name: 'Passant (x1) : ajout / retrait',
        prices: {
          SIMPLE: 4,
          COMPLEX: 8
        },
        id: '13.comb-ret-div-3',
        multiple: true
      }, {
        name: 'Pince (x1) : ajout',
        prices: {
          SIMPLE: 8,
          COMPLEX: 12
        },
        id: '13.comb-ret-div-4',
        multiple: true
      }, {
        name: 'Fente : ajout / retrait',
        prices: {
          SIMPLE: 12,
          COMPLEX: 18
        },
        id: '13.comb-ret-div-5'
      }, {
        name: 'Élastique : ajout',
        prices: {
          SIMPLE: 7,
          COMPLEX: 17
        },
        id: '13.comb-ret-div-6'
      }, {
        name: 'Perlage (5 à 10 perles)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 17
        },
        id: '13.comb-ret-div-7',
        multiple: true
      }, {
        name: 'Poche plate simple (x1) : ajout/retrait',
        prices: {
          SIMPLE: 10,
          COMPLEX: 15
        },
        id: '13.comb-ret-div-8',
        multiple: true
      }, {
        name: 'Poche intérieure classique (x1) : ajout',
        prices: {
          SIMPLE: 15,
          COMPLEX: 19
        },
        id: '13.comb-ret-div-9',
        multiple: true
      }, {
        name: 'Poche complexe (x1) : ajout',
        prices: {
          SIMPLE: 20,
          COMPLEX: 22
        },
        id: '13.comb-ret-div-10',
        multiple: true
      }, {
        name: 'Scratch < 30cm',
        prices: {
          SIMPLE: 5,
          COMPLEX: 9
        },
        id: '13.comb-ret-div-11'
      }, {
        name: 'Scratch > 30cm',
        prices: {
          SIMPLE: 7,
          COMPLEX: 11
        },
        id: '13.comb-ret-div-12'
      }, {
        name: 'Crochets (x1) : ajout / retrait',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '13.comb-ret-div-13',
        multiple: true
      }, {
        name: 'Bretelles (x2) : ajout / retrait',
        prices: {
          SIMPLE: 12,
          COMPLEX: 18
        },
        id: '13.comb-ret-div-14'
      }, {
        name: 'Épaulettes (x2) : ajout / retrait',
        prices: {
          SIMPLE: 18,
          COMPLEX: 21
        },
        liningPrices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        id: '13.comb-ret-div-15'
      }, {
        name: 'Oeillet petit (x1) : ajout',
        prices: {
          SIMPLE: 1,
          COMPLEX: 1
        },
        multiple: true,
        id: '13.comb-ret-div-16'
      }, {
        name: 'Couture de finition simple',
        prices: {
          SIMPLE: 4,
          COMPLEX: 6
        },
        multiple: true,
        id: '13.comb-ret-div-17',
        mostCommonCategoryPosition: 6,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition complexe',
        prices: {
          SIMPLE: 10,
          COMPLEX: 12
        },
        multiple: true,
        id: '13.comb-ret-div-18',
        mostCommonCategoryPosition: 7,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition avec empiècement',
        prices: {
          SIMPLE: 15,
          COMPLEX: 19
        },
        multiple: true,
        id: '13.comb-ret-div-19',
        mostCommonCategoryPosition: 8,
        onlyCouturiers: true
      }, {
        name: '1h de conseil',
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        id: '13.comb-ret-div-20'
      }]
    }]
  }, {
    name: 'Réparer',
    slug: 'repair',
    subCategories: [(0, _commonPricings.getCommunTearRepair)({
      slug: 'comb',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunZipsRepair)({
      slug: 'comb',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunButtonsRepair)({
      slug: 'comb',
      isSuitableForJunior: true
    }), {
      name: 'Plus de réparations',
      slug: 'more_repair',
      items: [{
        name: 'Coudière / genouillère (x2) : réparation / remplacement',
        prices: {
          SIMPLE: 17,
          COMPLEX: 20
        },
        id: '13.comb-rep-div-1',
        repairBonus: 'HOLE'
      }, {
        name: 'Doublure : réparation / remplacement',
        prices: {
          SIMPLE: 35,
          COMPLEX: 60
        },
        id: '13.comb-rep-div-2',
        repairBonus: {
          SIMPLE: 'LINING_SIMPLE',
          COMPLEX: 'LINING_COMPLEX'
        }
      }, {
        name: 'Doublure - sac de poche : réparation / remplacement',
        prices: {
          SIMPLE: 17,
          COMPLEX: 19
        },
        id: '13.comb-rep-div-3',
        repairBonus: 'LINING_SIMPLE'
      }, {
        name: 'Crochets (x1) : réparation / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '13.comb-rep-div-4'
      }, {
        name: 'Ourlet - décousu (x2 jambes)',
        prices: {
          SIMPLE: 12,
          COMPLEX: 14
        },
        id: '13.comb-rep-div-5',
        repairBonus: 'UNTIED_UNLINED'
      }]
    }]
  }, {
    name: 'Broder',
    slug: 'embroidery',
    subCategories: [(0, _commonPricings.getEmbroideryPricingsCategory)('comb', undefined)]
  }]
}, {
  name: 'Robe de mariée',
  slug: 'mari',
  hasMostCommonCategory: true,
  types: undefined,
  categories: [{
    name: 'Retoucher',
    slug: 'alteration',
    subCategories: [{
      name: 'Cintrer',
      slug: 'cin_alteration',
      items: [{
        name: 'Côtés (x2)',
        prices: {
          DEFAULT: 63
        },
        liningPrices: {
          DEFAULT: 28
        },
        id: '13.mari-ret-cin-1'
      }, {
        name: 'Épaules (x2)',
        prices: {
          DEFAULT: 42
        },
        liningPrices: {
          DEFAULT: 8
        },
        id: '13.mari-ret-cin-2'
      }, {
        name: 'Manches (x2 - sans boutonnière)',
        prices: {
          DEFAULT: 49
        },
        id: '13.mari-ret-cin-3'
      }, {
        name: 'Manches (x2 - boutonnière)',
        prices: {
          DEFAULT: 63
        },
        id: '13.mari-ret-cin-4'
      }, {
        name: 'Bustier / taille',
        prices: {
          DEFAULT: 70
        },
        liningPrices: {
          DEFAULT: 8
        },
        id: '13.mari-ret-cin-5',
        mostCommonCategoryPosition: 5,
        mostCommonCategoryLabel: 'Cintrer taille'
      }, {
        name: 'Dos',
        prices: {
          DEFAULT: 63
        },
        liningPrices: {
          DEFAULT: 8
        },
        id: '13.mari-ret-cin-6'
      }]
    }, {
      name: 'Élargir',
      slug: 'ela_alteration',
      items: [{
        name: 'Côtés (x2)',
        prices: {
          DEFAULT: 63
        },
        liningPrices: {
          DEFAULT: 28
        },
        id: '13.mari-ret-ela-1'
      }, {
        name: 'Épaules (x2)',
        prices: {
          DEFAULT: 42
        },
        liningPrices: {
          DEFAULT: 8
        },
        id: '13.mari-ret-ela-2'
      }, {
        name: 'Manches (x2 - sans boutonnière)',
        prices: {
          DEFAULT: 49
        },
        id: '13.mari-ret-ela-3'
      }, {
        name: 'Manches (x2 - boutonnière)',
        prices: {
          DEFAULT: 63
        },
        id: '13.mari-ret-ela-4'
      }, {
        name: 'Bustier / taille',
        prices: {
          DEFAULT: 70
        },
        liningPrices: {
          DEFAULT: 8
        },
        id: '13.mari-ret-ela-5'
      }, {
        name: 'Dos',
        prices: {
          DEFAULT: 63
        },
        liningPrices: {
          DEFAULT: 8
        },
        id: '13.mari-ret-ela-6'
      }]
    }, {
      name: 'Raccourcir',
      slug: 'rac_alteration',
      items: [{
        name: 'Ourlet simple',
        prices: {
          DEFAULT: 63
        },
        liningPrices: {
          DEFAULT: 13
        },
        id: '13.mari-ret-rac-1',
        mostCommonCategoryPosition: 1
      }, {
        name: 'Ourlet à volants',
        prices: {
          DEFAULT: 84
        },
        liningPrices: {
          DEFAULT: 15
        },
        id: '13.mari-ret-rac-2'
      }, {
        name: 'Ourlet revers',
        prices: {
          DEFAULT: 65
        },
        liningPrices: {
          DEFAULT: 13
        },
        id: '13.mari-ret-rac-3'
      }, {
        name: 'Manches (x2 - sans boutonnière)',
        prices: {
          DEFAULT: 23
        },
        id: '13.mari-ret-rac-4'
      }, {
        name: 'Manches (x2 - boutonnière)',
        prices: {
          DEFAULT: 32
        },
        id: '13.mari-ret-rac-5'
      }, {
        name: 'Bretelles (x2)',
        prices: {
          DEFAULT: 28
        },
        id: '13.mari-ret-rac-6'
      }]
    }, {
      name: 'Rallonger',
      slug: 'ral_alteration',
      items: [{
        name: 'Longueur simple',
        prices: {
          DEFAULT: 63
        },
        liningPrices: {
          DEFAULT: 13
        },
        id: '13.mari-ret-ral-1'
      }, {
        name: 'Longueur à volants',
        prices: {
          DEFAULT: 84
        },
        liningPrices: {
          DEFAULT: 15
        },
        id: '13.mari-ret-ral-2'
      }, {
        name: 'Ourlets (x2) : suppression des revers',
        prices: {
          DEFAULT: 59
        },
        liningPrices: {
          DEFAULT: 11
        },
        id: '13.mari-ret-ral-3'
      }, {
        name: 'Manches (x2 - sans boutonnière)',
        prices: {
          DEFAULT: 23
        },
        id: '13.mari-ret-ral-4'
      }, {
        name: 'Manches (x2 - boutonnière)',
        prices: {
          DEFAULT: 32
        },
        id: '13.mari-ret-ral-5'
      }, {
        name: 'Bretelles (x2)',
        prices: {
          DEFAULT: 28
        },
        id: '13.mari-ret-ral-6'
      }]
    }, {
      name: 'Zips',
      slug: 'zip_alteration',
      onlyCouturiers: true,
      items: [{
        name: 'Zip court (< 25cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          DEFAULT: 30
        },
        liningPrices: {
          DEFAULT: 13
        },
        id: '13.mari-ret-zip-1',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip moyen (25-40cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          DEFAULT: 43
        },
        liningPrices: {
          DEFAULT: 13
        },
        id: '13.mari-ret-zip-2',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip long (40-80cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          DEFAULT: 62
        },
        liningPrices: {
          DEFAULT: 12
        },
        id: '13.mari-ret-zip-3',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip court (< 25cm) fourni par le client : réparation / remplacement',
        prices: {
          DEFAULT: 47
        },
        liningPrices: {
          DEFAULT: 13
        },
        id: '13.mari-ret-zip-4',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip moyen (25-40cm) fourni par le client : réparation / remplacement',
        prices: {
          DEFAULT: 43
        },
        liningPrices: {
          DEFAULT: 13
        },
        id: '13.mari-ret-zip-5',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip long (40-80cm) fourni par le client : réparation / remplacement',
        prices: {
          DEFAULT: 53
        },
        liningPrices: {
          DEFAULT: 12
        },
        id: '13.mari-ret-zip-6',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip invisible court (< 25cm) fourni par le Tilliste : réparation / remplacement',
        prices: {
          DEFAULT: 56
        },
        liningPrices: {
          DEFAULT: 12
        },
        id: '13.mari-ret-zip-7',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip invisible moyen (25-40cm) fourni par le Tilliste : réparation / remplacement',
        prices: {
          DEFAULT: 60
        },
        liningPrices: {
          DEFAULT: 13
        },
        id: '13.mari-ret-zip-8',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip invisible long (40-80cm) fourni par le Tilliste : réparation / remplacement',
        prices: {
          DEFAULT: 63
        },
        liningPrices: {
          DEFAULT: 15
        },
        id: '13.mari-ret-zip-9',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip invisible court (< 25cm) fourni par le client : réparation / remplacement',
        prices: {
          DEFAULT: 43
        },
        liningPrices: {
          DEFAULT: 12
        },
        id: '13.mari-ret-zip-10',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip invisible moyen (25-40cm) fourni par le client : réparation / remplacement',
        prices: {
          DEFAULT: 47
        },
        liningPrices: {
          DEFAULT: 13
        },
        id: '13.mari-ret-zip-11',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip invisible long (40-80cm) fourni par le client : réparation / remplacement',
        prices: {
          DEFAULT: 50
        },
        liningPrices: {
          DEFAULT: 15
        },
        id: '13.mari-ret-zip-12',
        multiple: true,
        onlyCouturiers: true
      }]
    }, {
      name: 'Boutons',
      slug: 'but_alteration',
      onlyCouturiers: true,
      items: [{
        name: 'Boutonnière (x1) : création',
        prices: {
          DEFAULT: 10
        },
        liningPrices: {
          DEFAULT: 2
        },
        id: '13.mari-ret-but-1',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          DEFAULT: 4
        },
        id: '13.mari-ret-but-2',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton (x1) fourni par le client : ajout / remplacement',
        prices: {
          DEFAULT: 2
        },
        id: '13.mari-ret-but-4',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à coudre (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          DEFAULT: 3
        },
        id: '13.mari-ret-but-5',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à coudre (x1) fourni par le client : ajout / remplacement',
        prices: {
          DEFAULT: 2
        },
        id: '13.mari-ret-but-6',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à poser (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          DEFAULT: 8
        },
        id: '13.mari-ret-but-7',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à poser (x1) fourni par le client : ajout / remplacement',
        prices: {
          DEFAULT: 6
        },
        id: '13.mari-ret-but-8',
        multiple: true,
        onlyCouturiers: true
      }]
    }, {
      name: 'Plus de retouches',
      slug: 'more_alteration',
      items: [{
        name: 'Doublure : ajout / retrait',
        prices: {
          DEFAULT: 69
        },
        id: '13.mari-ret-div-1'
      }, {
        name: 'Passant (x1) : ajout / retrait',
        prices: {
          DEFAULT: 10
        },
        id: '13.mari-ret-div-3',
        multiple: true
      }, {
        name: 'Pince (x1) : ajout',
        prices: {
          DEFAULT: 25
        },
        id: '13.mari-ret-div-4',
        multiple: true
      }, {
        name: 'Fente : ajout / retrait',
        prices: {
          DEFAULT: 29
        },
        id: '13.mari-ret-div-5'
      }, {
        name: 'Élastique : ajout',
        prices: {
          DEFAULT: 22
        },
        id: '13.mari-ret-div-6'
      }, {
        name: 'Perlage (5 à 10 perles)',
        prices: {
          DEFAULT: 35
        },
        id: '13.mari-ret-div-7',
        multiple: true
      }, {
        name: 'Poche plate simple (x1) : ajout/retrait',
        prices: {
          DEFAULT: 18
        },
        id: '13.mari-ret-div-8',
        multiple: true
      }, {
        name: 'Poche classique (x1) : ajout',
        prices: {
          DEFAULT: 22
        },
        id: '13.mari-ret-div-9',
        multiple: true
      }, {
        name: 'Poche complexe (x1) : ajout',
        prices: {
          DEFAULT: 27
        },
        id: '13.mari-ret-div-10',
        multiple: true
      }, {
        name: 'Crochets (x1) : ajout',
        prices: {
          DEFAULT: 10
        },
        id: '13.mari-ret-div-12',
        multiple: true
      }, {
        name: 'Bretelles (x2) : ajout / retrait',
        prices: {
          DEFAULT: 18
        },
        id: '13.mari-ret-div-13'
      }, {
        name: 'Épaulettes (x2) : ajout / retrait',
        prices: {
          DEFAULT: 35
        },
        id: '13.mari-ret-div-14'
      }, {
        name: 'Ceinture : ajout / retrait',
        prices: {
          DEFAULT: 42
        },
        multiple: true,
        id: '13.mari-ret-div-15'
      }, {
        name: 'Oeillet petit (x1) : ajout',
        prices: {
          DEFAULT: 2
        },
        multiple: true,
        id: '13.mari-ret-div-16'
      }, {
        name: 'Couture de finition simple',
        prices: {
          DEFAULT: 13
        },
        liningPrices: {
          DEFAULT: 2
        },
        multiple: true,
        id: '13.mari-ret-div-17',
        mostCommonCategoryPosition: 6,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition complexe',
        prices: {
          DEFAULT: 22
        },
        liningPrices: {
          DEFAULT: 2
        },
        multiple: true,
        id: '13.mari-ret-div-18',
        mostCommonCategoryPosition: 7,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition avec empiècement',
        prices: {
          DEFAULT: 30
        },
        multiple: true,
        id: '13.mari-ret-div-19',
        mostCommonCategoryPosition: 8,
        onlyCouturiers: true
      }, {
        name: '1h de conseil',
        prices: {
          DEFAULT: 60
        },
        id: '13.mari-ret-div-20'
      }]
    }]
  }, {
    name: 'Réparer',
    slug: 'repair',
    subCategories: [{
      name: 'Déchirures / trous',
      slug: 'tear_repair',
      items: [{
        name: 'Déchirure : réparation',
        prices: {
          DEFAULT: 29
        },
        liningPrices: {
          DEFAULT: 8
        },
        id: '13.mari-rep-tear-1',
        multiple: true,
        repairBonus: 'HOLE',
        mostCommonCategoryPosition: 3
      }, {
        name: 'Couture décousue simple',
        prices: {
          DEFAULT: 21
        },
        liningPrices: {
          DEFAULT: 2
        },
        id: '13.mari-rep-tear-2',
        multiple: true,
        repairBonus: 'UNTIED_UNLINED',
        mostCommonCategoryPosition: 4
      }, {
        name: 'Couture décousue complexe',
        prices: {
          DEFAULT: 23
        },
        liningPrices: {
          DEFAULT: 2
        },
        id: '13.mari-rep-tear-3',
        multiple: true,
        repairBonus: 'UNTIED_UNLINED'
      }]
    }, {
      name: 'Zips',
      slug: 'zip_repair',
      items: [{
        name: 'Zip court (< 25cm) fourni par le Tilliste : réparation / remplacement',
        prices: {
          DEFAULT: 30
        },
        liningPrices: {
          DEFAULT: 13
        },
        id: '13.mari-rep-zip-1',
        multiple: true,
        repairBonus: 'ZIP_SMALL',
        mostCommonCategoryPosition: 2
      }, {
        name: 'Zip moyen (25-40cm) fourni par le Tilliste : réparation / remplacement',
        prices: {
          DEFAULT: 43
        },
        liningPrices: {
          DEFAULT: 13
        },
        id: '13.mari-rep-zip-2',
        multiple: true,
        repairBonus: 'ZIP_BIG'
      }, {
        name: 'Zip long (40-80cm) fourni par le Tilliste : réparation / remplacement',
        prices: {
          DEFAULT: 62
        },
        liningPrices: {
          DEFAULT: 12
        },
        id: '13.mari-rep-zip-3',
        multiple: true,
        repairBonus: 'ZIP_BIG'
      }, {
        name: 'Zip invisible court (< 25cm) fourni par le Tilliste : réparation / remplacement',
        prices: {
          DEFAULT: 56
        },
        liningPrices: {
          DEFAULT: 12
        },
        id: '13.mari-rep-zip-4',
        multiple: true,
        repairBonus: 'ZIP_SMALL'
      }, {
        name: 'Zip invisible moyen (25-40cm) fourni par le Tilliste : réparation / remplacement',
        prices: {
          DEFAULT: 60
        },
        liningPrices: {
          DEFAULT: 13
        },
        id: '13.mari-rep-zip-5',
        multiple: true,
        repairBonus: 'ZIP_BIG'
      }, {
        name: 'Zip invisible long (40-80cm) fourni par le Tilliste : réparation / remplacement',
        prices: {
          DEFAULT: 63
        },
        liningPrices: {
          DEFAULT: 15
        },
        id: '13.mari-rep-zip-6',
        multiple: true,
        repairBonus: 'ZIP_BIG'
      }, {
        name: 'Zip court (< 25cm) fourni par le client : réparation / remplacement',
        prices: {
          DEFAULT: 47
        },
        liningPrices: {
          DEFAULT: 13
        },
        id: '13.mari-rep-zip-7',
        multiple: true,
        repairBonus: 'ZIP_SMALL'
      }, {
        name: 'Zip moyen (25-40cm) fourni par le client : réparation / remplacement',
        prices: {
          DEFAULT: 43
        },
        liningPrices: {
          DEFAULT: 13
        },
        id: '13.mari-rep-zip-8',
        multiple: true,
        repairBonus: 'ZIP_BIG'
      }, {
        name: 'Zip long (40-80cm) fourni par le client : réparation / remplacement',
        prices: {
          DEFAULT: 53
        },
        liningPrices: {
          DEFAULT: 12
        },
        id: '13.mari-rep-zip-9',
        multiple: true,
        repairBonus: 'ZIP_BIG'
      }, {
        name: 'Zip invisible court (< 25cm) fourni par le client : réparation / remplacement',
        prices: {
          DEFAULT: 43
        },
        liningPrices: {
          DEFAULT: 12
        },
        id: '13.mari-rep-zip-10',
        multiple: true,
        repairBonus: 'ZIP_SMALL'
      }, {
        name: 'Zip invisible moyen (25-40cm) fourni par le client : réparation / remplacement',
        prices: {
          DEFAULT: 47
        },
        liningPrices: {
          DEFAULT: 13
        },
        id: '13.mari-rep-zip-11',
        multiple: true,
        repairBonus: 'ZIP_BIG'
      }, {
        name: 'Zip invisible long (40-80cm) fourni par le client : réparation / remplacement',
        prices: {
          DEFAULT: 50
        },
        liningPrices: {
          DEFAULT: 15
        },
        id: '13.mari-rep-zip-12',
        multiple: true,
        repairBonus: 'ZIP_BIG'
      }]
    }, {
      name: 'Boutons',
      slug: 'but_repair',
      items: [{
        name: 'Boutonnière (x1) : création',
        prices: {
          DEFAULT: 10
        },
        liningPrices: {
          DEFAULT: 2
        },
        id: '13.mari-rep-but-1',
        multiple: true
      }, {
        name: 'Bouton (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          DEFAULT: 4
        },
        id: '13.mari-rep-but-2',
        multiple: true
      }, {
        name: 'Bouton (x1) fourni par le client : ajout / remplacement',
        prices: {
          DEFAULT: 2
        },
        id: '13.mari-rep-but-4',
        multiple: true
      }, {
        name: 'Bouton pression à coudre (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          DEFAULT: 3
        },
        id: '13.mari-rep-but-5',
        multiple: true
      }, {
        name: 'Bouton pression à coudre (x1) fourni par le client : ajout / remplacement',
        prices: {
          DEFAULT: 2
        },
        id: '13.mari-rep-but-6',
        multiple: true
      }, {
        name: 'Bouton pression à poser (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          DEFAULT: 8
        },
        id: '13.mari-rep-but-7',
        multiple: true
      }, {
        name: 'Bouton pression à poser (x1) fourni par le client : ajout / remplacement',
        prices: {
          DEFAULT: 6
        },
        id: '13.mari-rep-but-8',
        multiple: true
      }]
    }, {
      name: 'Plus de réparations',
      slug: 'more_repair',
      items: [{
        name: 'Doublure : réparation / remplacement',
        prices: {
          DEFAULT: 69
        },
        id: '13.mari-rep-div-1',
        repairBonus: 'LINING_COMPLEX'
      }, {
        name: 'Crochets (x1) : réparation / remplacement',
        prices: {
          DEFAULT: 10
        },
        id: '13.mari-rep-div-2'
      }, {
        name: 'Ourlet - décousu',
        prices: {
          DEFAULT: 25
        },
        liningPrices: {
          DEFAULT: 13
        },
        id: '13.mari-rep-div-3',
        repairBonus: 'UNTIED_LINED'
      }]
    }]
  }, {
    name: 'Broder',
    slug: 'embroidery',
    subCategories: [(0, _commonPricings.getEmbroideryPricingsCategory)('mari', 'mari')]
  }]
}, {
  name: 'Accessoires',
  slug: 'acce',
  hasMostCommonCategory: false,
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Habillé'
  }],
  categories: [{
    name: 'Retoucher',
    slug: 'alteration',
    subCategories: [(0, _commonPricings.getCommunZipsAlteration)({
      slug: 'acce',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunButtonsAlteration)({
      slug: 'acce',
      isSuitableForJunior: true
    }), {
      name: 'Plus de retouches',
      slug: 'more_alteration',
      items: [{
        name: 'Doublure : ajout / retrait',
        prices: {
          SIMPLE: 9,
          COMPLEX: 12
        },
        id: '13.acce-ret-div-1'
      }, {
        name: 'Passant (x1) : ajout / retrait',
        prices: {
          SIMPLE: 4,
          COMPLEX: 8
        },
        id: '13.acce-ret-div-3',
        multiple: true
      }, {
        name: 'Pince (x1) : ajout',
        prices: {
          SIMPLE: 8,
          COMPLEX: 12
        },
        id: '13.acce-ret-div-4',
        multiple: true
      }, {
        name: 'Fente : ajout / retrait',
        prices: {
          SIMPLE: 12,
          COMPLEX: 18
        },
        id: '13.acce-ret-div-5'
      }, {
        name: 'Élastique : ajout',
        prices: {
          SIMPLE: 7,
          COMPLEX: 17
        },
        id: '13.acce-ret-div-6'
      }, {
        name: 'Perlage (5 à 10 perles)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 17
        },
        id: '13.acce-ret-div-7',
        multiple: true
      }, {
        name: 'Poche plate simple (x1) : ajout/retrait',
        prices: {
          SIMPLE: 10,
          COMPLEX: 15
        },
        id: '13.acce-ret-div-8',
        multiple: true
      }, {
        name: 'Poche intérieure classique (x1) : ajout',
        prices: {
          SIMPLE: 15,
          COMPLEX: 19
        },
        id: '13.acce-ret-div-9',
        multiple: true
      }, {
        name: 'Poche complexe (x1) : ajout',
        prices: {
          SIMPLE: 20,
          COMPLEX: 22
        },
        id: '13.acce-ret-div-10',
        multiple: true
      }, {
        name: 'Scratch < 30cm',
        prices: {
          SIMPLE: 5,
          COMPLEX: 9
        },
        id: '13.acce-ret-div-11'
      }, {
        name: 'Scratch > 30cm',
        prices: {
          SIMPLE: 7,
          COMPLEX: 11
        },
        id: '13.acce-ret-div-12'
      }, {
        name: 'Crochets (x1) : ajout / retrait',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '13.acce-ret-div-13',
        multiple: true
      }, {
        name: 'Oeillet petit (x1) : ajout',
        prices: {
          SIMPLE: 1,
          COMPLEX: 1
        },
        multiple: true,
        id: '13.acce-ret-div-14'
      }, {
        name: 'Oeillet moyen (x1) : ajout',
        prices: {
          SIMPLE: 4,
          COMPLEX: 4
        },
        multiple: true,
        id: '13.acce-ret-div-15'
      }, {
        name: 'Couture de finition simple',
        prices: {
          SIMPLE: 4,
          COMPLEX: 6
        },
        multiple: true,
        id: '13.acce-ret-div-16',
        mostCommonCategoryPosition: 6,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition complexe',
        prices: {
          SIMPLE: 10,
          COMPLEX: 12
        },
        multiple: true,
        id: '13.acce-ret-div-17',
        mostCommonCategoryPosition: 7,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition avec empiècement',
        prices: {
          SIMPLE: 15,
          COMPLEX: 19
        },
        multiple: true,
        id: '13.acce-ret-div-18',
        mostCommonCategoryPosition: 8,
        onlyCouturiers: true
      }, {
        name: '1h de conseil',
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        id: '13.acce-ret-div-19'
      }]
    }]
  }, {
    name: 'Réparer',
    slug: 'repair',
    subCategories: [(0, _commonPricings.getCommunTearRepair)({
      slug: 'acce',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunZipsRepair)({
      slug: 'acce',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunButtonsRepair)({
      slug: 'acce',
      isSuitableForJunior: true
    }), {
      name: 'Plus de réparations',
      slug: 'more_repair',
      items: [{
        name: 'Doublure : réparation / remplacement',
        prices: {
          SIMPLE: 9,
          COMPLEX: 12
        },
        id: '13.acce-rep-div-1'
      }, {
        name: 'Doublure - sac de poche : réparation / remplacement',
        prices: {
          SIMPLE: 17,
          COMPLEX: 19
        },
        id: '13.acce-rep-div-2'
      }, {
        name: 'Crochets (x1) : réparation / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '13.acce-rep-div-3'
      }]
    }]
  }, {
    name: 'Broder',
    slug: 'embroidery',
    subCategories: [(0, _commonPricings.getEmbroideryPricingsCategory)('acce', undefined), (0, _commonPricings.getCommunMachineEmbroidery)({
      slug: 'acce'
    })]
  }]
}, {
  name: 'Petit accessoire',
  slug: 'little_acce',
  hasMostCommonCategory: false,
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Habillé'
  }],
  categories: [{
    name: 'Réparer',
    slug: 'repair',
    subCategories: [(0, _commonPricings.getCommunTearRepair)({
      slug: 'little_acce',
      isSuitableForJunior: true
    })]
  }, {
    name: 'Broder',
    slug: 'embroidery',
    subCategories: [(0, _commonPricings.getEmbroideryPricingsCategory)('little_acce', undefined)]
  }]
}, {
  name: 'Rideaux',
  slug: 'ride',
  hasMostCommonCategory: false,
  types: undefined,
  categories: [{
    name: 'Retoucher',
    slug: 'alteration',
    subCategories: [{
      name: 'Les plus courants',
      slug: 'mostCommon',
      items: [{
        name: 'Ourlet - largeur <199cm',
        isSuitableForJunior: true,
        prices: {
          DEFAULT: 20
        },
        liningPrices: {
          DEFAULT: 10
        },
        id: '13.ride-ret-1',
        multiple: true
      }, {
        name: 'Ourlet - largeur <299cm',
        isSuitableForJunior: true,
        prices: {
          DEFAULT: 30
        },
        liningPrices: {
          DEFAULT: 10
        },
        id: '13.ride-ret-2',
        multiple: true
      }, {
        name: 'Supplément fil de plomb',
        isSuitableForJunior: true,
        prices: {
          DEFAULT: 10
        },
        id: '13.ride-ret-3',
        multiple: true
      }, {
        name: 'Assemblage côté - hauteur <199cm',
        isSuitableForJunior: true,
        prices: {
          DEFAULT: 30
        },
        liningPrices: {
          DEFAULT: 10
        },
        id: '13.ride-ret-4',
        multiple: true
      }, {
        name: 'Assemblage côté - hauteur >200cm',
        isSuitableForJunior: true,
        prices: {
          DEFAULT: 40
        },
        liningPrices: {
          DEFAULT: 10
        },
        id: '13.ride-ret-5',
        multiple: true
      }, {
        name: 'Ajout de fronces - largeur <199cm',
        isSuitableForJunior: true,
        prices: {
          DEFAULT: 30
        },
        id: '13.ride-ret-6',
        multiple: true
      }, {
        name: 'Ajout de fronces - largeur >200cm',
        isSuitableForJunior: true,
        prices: {
          DEFAULT: 37
        },
        id: '13.ride-ret-7',
        multiple: true
      }, {
        name: 'Dépose/pose d’un pan de rideau',
        isSuitableForJunior: true,
        prices: {
          DEFAULT: 15
        },
        id: '13.ride-ret-8',
        multiple: true
      }, {
        name: 'Ourlet - par mètre supplémentaire',
        isSuitableForJunior: true,
        prices: {
          DEFAULT: 10
        },
        id: '13.ride-ret-9',
        multiple: true
      }]
    }, {
      name: 'Plus de retouches',
      slug: 'more_alteration',
      items: [{
        name: 'Couture de finition simple',
        prices: {
          DEFAULT: 4
        },
        id: '13.ride-ret-div-1'
      }, {
        name: 'Couture de finition complexe',
        prices: {
          DEFAULT: 12
        },
        id: '13.ride-ret-div-2'
      }, {
        name: 'Couture de finition avec empiècement',
        prices: {
          DEFAULT: 15
        },
        id: '13.ride-ret-div-3'
      }, {
        name: 'Doublure : ajout / remplacement',
        prices: {
          DEFAULT: 35
        },
        id: '13.ride-ret-div-4'
      }]
    }]
  }, {
    name: 'Réparer',
    slug: 'repair',
    subCategories: [{
      name: 'Déchirures / trous',
      slug: 'tear_repair',
      items: [{
        name: 'Déchirure',
        isSuitableForJunior: true,
        prices: {
          DEFAULT: 16
        },
        id: '13.ride-rep-tear-1',
        multiple: true
      }, {
        name: 'Couture complexe avec empiècement',
        isSuitableForJunior: true,
        prices: {
          DEFAULT: 19
        },
        id: '13.ride-rep-tear-2',
        multiple: true
      }, {
        name: 'Trou : raccommodage simple',
        isSuitableForJunior: true,
        prices: {
          DEFAULT: 12
        },
        id: '13.ride-rep-tear-3',
        multiple: true
      }, {
        name: 'Trou : raccommodage complexe',
        isSuitableForJunior: true,
        prices: {
          DEFAULT: 17
        },
        id: '13.ride-rep-tear-4',
        multiple: true
      }, {
        name: 'Couture décousue simple',
        isSuitableForJunior: true,
        prices: {
          DEFAULT: 14
        },
        id: '13.ride-rep-tear-5',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Couture décousue complexe',
        isSuitableForJunior: true,
        prices: {
          DEFAULT: 16
        },
        id: '13.ride-rep-tear-6',
        multiple: true,
        onlyCouturiers: true
      }]
    }, (0, _commonPricings.getRepairInteriorButtons)({
      slug: 'ride'
    })]
  }, {
    name: 'Broder',
    slug: 'embroidery',
    subCategories: [(0, _commonPricings.getEmbroideryPricingsCategory)('ride', 'SIMPLE'), (0, _commonPricings.getCommunMachineEmbroidery)({
      slug: 'ride'
    })]
  }]
}, {
  name: 'Linge de lit',
  slug: 'mais',
  hasMostCommonCategory: false,
  types: undefined,
  categories: [{
    name: 'Retoucher',
    slug: 'alteration',
    subCategories: [{
      name: 'Les plus courants',
      slug: 'mostCommon',
      items: [{
        name: 'Raccourcir longueur - plus d’1m60',
        isSuitableForJunior: true,
        prices: {
          DEFAULT: 20
        },
        id: '13.mais-ret-1',
        multiple: true
      }, {
        name: 'Raccourcir largeur - plus d’1m60',
        isSuitableForJunior: true,
        prices: {
          DEFAULT: 20
        },
        id: '13.mais-ret-2',
        multiple: true
      }, {
        name: 'Raccourcir longueur et largeur - plus d’1m60',
        isSuitableForJunior: true,
        prices: {
          DEFAULT: 40
        },
        id: '13.mais-ret-3',
        multiple: true
      }, {
        name: 'Raccourcir longueur - moins d’1m60',
        isSuitableForJunior: true,
        prices: {
          DEFAULT: 15
        },
        id: '13.mais-ret-4',
        multiple: true
      }, {
        name: 'Raccourcir largeur - moins d’1m60',
        isSuitableForJunior: true,
        prices: {
          DEFAULT: 15
        },
        id: '13.mais-ret-5',
        multiple: true
      }, {
        name: 'Raccourcir longueur et largeur - moins d’1m60',
        isSuitableForJunior: true,
        prices: {
          DEFAULT: 30
        },
        id: '13.mais-ret-6',
        multiple: true
      }, {
        name: 'Raccourcir longueur - moins d’1m',
        isSuitableForJunior: true,
        prices: {
          DEFAULT: 10
        },
        id: '13.mais-ret-7',
        multiple: true
      }, {
        name: 'Raccourcir largeur - moins d’1m',
        isSuitableForJunior: true,
        prices: {
          DEFAULT: 10
        },
        id: '13.mais-ret-8',
        multiple: true
      }, {
        name: 'Raccourcir longueur et largeur - moins d’1m',
        isSuitableForJunior: true,
        prices: {
          DEFAULT: 20
        },
        id: '13.mais-ret-9',
        multiple: true
      }]
    }, {
      name: 'Plus de retouches',
      slug: 'more_alteration',
      items: [{
        name: 'Couture de finition simple',
        prices: {
          DEFAULT: 4
        },
        id: '13.mais-ret-div-1'
      }, {
        name: 'Couture de finition complexe',
        prices: {
          DEFAULT: 12
        },
        id: '13.mais-ret-div-2'
      }, {
        name: 'Couture de finition avec empiècement',
        prices: {
          DEFAULT: 15
        },
        id: '13.mais-ret-div-3'
      }, {
        name: 'Doublure : ajout / remplacement',
        prices: {
          DEFAULT: 35
        },
        id: '13.mais-ret-div-4'
      }]
    }]
  }, {
    name: 'Réparer',
    slug: 'repair',
    subCategories: [(0, _commonPricings.getRepairInteriorTears)({
      slug: 'mais'
    }), (0, _commonPricings.getRepairInteriorButtons)({
      slug: 'mais'
    })]
  }, {
    name: 'Broder',
    slug: 'embroidery',
    subCategories: [(0, _commonPricings.getEmbroideryPricingsCategory)('mais', 'SIMPLE'), (0, _commonPricings.getCommunMachineEmbroidery)({
      slug: 'mais'
    })]
  }]
}, {
  name: 'Coussins',
  slug: 'cous',
  hasMostCommonCategory: false,
  types: undefined,
  categories: [{
    name: 'Retoucher',
    slug: 'alteration',
    subCategories: [{
      name: 'Les plus courants',
      slug: 'mostCommon',
      items: [{
        name: 'Coussin (moins de 45 cm)',
        prices: {
          DEFAULT: 14
        },
        id: '13.cous-ret-1',
        multiple: true
      }, {
        name: 'Coussin (plus de 45 cm)',
        isSuitableForJunior: true,
        prices: {
          DEFAULT: 18
        },
        id: '13.cous-ret-2',
        multiple: true
      }, {
        name: 'Doublure : ajout / remplacement',
        isSuitableForJunior: true,
        prices: {
          DEFAULT: 9
        },
        id: '13.cous-ret-3'
      }]
    }, {
      name: 'Plus de retouches',
      slug: 'more_alteration',
      items: [{
        name: 'Couture de finition simple',
        prices: {
          DEFAULT: 4
        },
        id: '13.cous-ret-div-1'
      }, {
        name: 'Couture de finition complexe',
        prices: {
          DEFAULT: 12
        },
        id: '13.cous-ret-div-2'
      }, {
        name: 'Couture de finition avec empiècement',
        prices: {
          DEFAULT: 15
        },
        id: '13.cous-ret-div-3'
      }, {
        name: 'Doublure : ajout / remplacement',
        prices: {
          DEFAULT: 35
        },
        id: '13.cous-ret-div-4'
      }, {
        name: 'Passant (x1) : ajout / remplacement',
        prices: {
          DEFAULT: 4
        },
        id: '13.cous-ret-div-5',
        multiple: true
      }, {
        name: 'Pince (x1) : ajout',
        prices: {
          DEFAULT: 8
        },
        id: '13.cous-ret-div-6',
        multiple: true
      }, {
        name: 'Fente : ajout / retrait',
        prices: {
          DEFAULT: 12
        },
        id: '13.cous-ret-div-7'
      }, {
        name: 'Élastique : ajout',
        prices: {
          DEFAULT: 7
        },
        id: '13.cous-ret-div-8'
      }, {
        name: 'Perlage (5 à 10 perles)',
        prices: {
          DEFAULT: 15
        },
        id: '13.cous-ret-div-9',
        multiple: true
      }, {
        name: 'Poche (x1) : changement de doublure',
        prices: {
          DEFAULT: 17
        },
        id: '13.cous-ret-div-10',
        multiple: true
      }, {
        name: 'Poche plate simple (x1) : ajout/retrait',
        prices: {
          DEFAULT: 10
        },
        id: '13.cous-ret-div-11',
        multiple: true
      }, {
        name: 'Poche intérieure classique (x1) : ajout',
        prices: {
          DEFAULT: 15
        },
        id: '13.cous-ret-div-12',
        multiple: true
      }, {
        name: 'Poche complexe (x1) : ajout',
        prices: {
          DEFAULT: 20
        },
        id: '13.cous-ret-div-13',
        multiple: true
      }]
    }]
  }, {
    name: 'Réparer',
    slug: 'repair',
    subCategories: [(0, _commonPricings.getRepairInteriorTears)({
      slug: 'cous'
    }), (0, _commonPricings.getRepairInteriorZips)({
      slug: 'cous'
    }), (0, _commonPricings.getRepairInteriorButtons)({
      slug: 'cous'
    })]
  }, {
    name: 'Broder',
    slug: 'embroidery',
    subCategories: [(0, _commonPricings.getEmbroideryPricingsCategory)('cous', 'SIMPLE'), (0, _commonPricings.getCommunMachineEmbroidery)({
      slug: 'cous'
    })]
  }]
}, {
  name: 'Housse de chaise',
  slug: 'chair',
  hasMostCommonCategory: false,
  types: undefined,
  categories: [{
    name: 'Retoucher',
    slug: 'alteration',
    items: [{
      name: 'Couture de finition simple',
      prices: {
        DEFAULT: 4
      },
      id: '13.chair-ret-div-1'
    }, {
      name: 'Couture de finition complexe',
      prices: {
        DEFAULT: 12
      },
      id: '13.chair-ret-div-2'
    }, {
      name: 'Couture de finition avec empiècement',
      prices: {
        DEFAULT: 15
      },
      id: '13.chair-ret-div-3'
    }, {
      name: 'Doublure : ajout / remplacement',
      prices: {
        DEFAULT: 35
      },
      id: '13.chair-ret-div-4'
    }, {
      name: 'Passant (x1) : ajout / remplacement',
      prices: {
        DEFAULT: 4
      },
      id: '13.chair-ret-div-5',
      multiple: true
    }, {
      name: 'Pince (x1) : ajout',
      prices: {
        DEFAULT: 8
      },
      id: '13.chair-ret-div-6',
      multiple: true
    }, {
      name: 'Fente : ajout / retrait',
      prices: {
        DEFAULT: 12
      },
      id: '13.chair-ret-div-7'
    }, {
      name: 'Élastique : ajout',
      prices: {
        DEFAULT: 7
      },
      id: '13.chair-ret-div-8'
    }, {
      name: 'Perlage (5 à 10 perles)',
      prices: {
        DEFAULT: 15
      },
      id: '13.chair-ret-div-9',
      multiple: true
    }, {
      name: 'Poche (x1) : changement de doublure',
      prices: {
        DEFAULT: 17
      },
      id: '13.chair-ret-div-10',
      multiple: true
    }, {
      name: 'Poche plate simple (x1) : ajout/retrait',
      prices: {
        DEFAULT: 10
      },
      id: '13.chair-ret-div-11',
      multiple: true
    }, {
      name: 'Poche intérieure classique (x1) : ajout',
      prices: {
        DEFAULT: 15
      },
      id: '13.chair-ret-div-12',
      multiple: true
    }, {
      name: 'Poche complexe (x1) : ajout',
      prices: {
        DEFAULT: 20
      },
      id: '13.chair-ret-div-13',
      multiple: true
    }]
  }, {
    name: 'Réparer',
    slug: 'repair',
    subCategories: [(0, _commonPricings.getRepairInteriorTears)({
      slug: 'chair'
    }), (0, _commonPricings.getRepairInteriorZips)({
      slug: 'chair'
    }), (0, _commonPricings.getRepairInteriorButtons)({
      slug: 'chair'
    })]
  }, {
    name: 'Broder',
    slug: 'embroidery',
    subCategories: [(0, _commonPricings.getEmbroideryPricingsCategory)('chair', 'SIMPLE'), (0, _commonPricings.getCommunMachineEmbroidery)({
      slug: 'chair'
    })]
  }]
}, {
  name: 'Housse de canapé',
  slug: 'sofa',
  hasMostCommonCategory: false,
  types: undefined,
  categories: [{
    name: 'Retoucher',
    slug: 'alteration',
    items: [{
      name: 'Couture de finition simple',
      prices: {
        DEFAULT: 4
      },
      id: '13.sofa-ret-div-1'
    }, {
      name: 'Couture de finition complexe',
      prices: {
        DEFAULT: 12
      },
      id: '13.sofa-ret-div-2'
    }, {
      name: 'Couture de finition avec empiècement',
      prices: {
        DEFAULT: 15
      },
      id: '13.sofa-ret-div-3'
    }, {
      name: 'Doublure : ajout / remplacement',
      prices: {
        DEFAULT: 35
      },
      id: '13.sofa-ret-div-4'
    }, {
      name: 'Passant (x1) : ajout / remplacement',
      prices: {
        DEFAULT: 4
      },
      id: '13.sofa-ret-div-5',
      multiple: true
    }, {
      name: 'Pince (x1) : ajout',
      prices: {
        DEFAULT: 8
      },
      id: '13.sofa-ret-div-6',
      multiple: true
    }, {
      name: 'Fente : ajout / retrait',
      prices: {
        DEFAULT: 12
      },
      id: '13.sofa-ret-div-7'
    }, {
      name: 'Élastique : ajout',
      prices: {
        DEFAULT: 7
      },
      id: '13.sofa-ret-div-8'
    }, {
      name: 'Perlage (5 à 10 perles)',
      prices: {
        DEFAULT: 15
      },
      id: '13.sofa-ret-div-9',
      multiple: true
    }, {
      name: 'Poche (x1) : changement de doublure',
      prices: {
        DEFAULT: 17
      },
      id: '13.sofa-ret-div-10',
      multiple: true
    }, {
      name: 'Poche plate simple (x1) : ajout/retrait',
      prices: {
        DEFAULT: 10
      },
      id: '13.sofa-ret-div-11',
      multiple: true
    }, {
      name: 'Poche intérieure classique (x1) : ajout',
      prices: {
        DEFAULT: 15
      },
      id: '13.sofa-ret-div-12',
      multiple: true
    }, {
      name: 'Poche complexe (x1) : ajout',
      prices: {
        DEFAULT: 20
      },
      id: '13.sofa-ret-div-13',
      multiple: true
    }]
  }, {
    name: 'Réparer',
    slug: 'repair',
    subCategories: [(0, _commonPricings.getRepairInteriorTears)({
      slug: 'sofa'
    }), (0, _commonPricings.getRepairInteriorZips)({
      slug: 'sofa'
    }), (0, _commonPricings.getRepairInteriorButtons)({
      slug: 'sofa'
    })]
  }, {
    name: 'Broder',
    slug: 'embroidery',
    subCategories: [(0, _commonPricings.getEmbroideryPricingsCategory)('sofa', 'SIMPLE'), (0, _commonPricings.getCommunMachineEmbroidery)({
      slug: 'sofa'
    })]
  }]
}, {
  name: 'Linge de table',
  slug: 'tableClothes',
  hasMostCommonCategory: false,
  types: undefined,
  categories: [{
    name: 'Retoucher',
    slug: 'alteration',
    items: [{
      name: 'Couture de finition simple',
      prices: {
        DEFAULT: 4
      },
      id: '13.tableClothes-ret-div-1'
    }, {
      name: 'Couture de finition complexe',
      prices: {
        DEFAULT: 12
      },
      id: '13.tableClothes-ret-div-2'
    }, {
      name: 'Couture de finition avec empiècement',
      prices: {
        DEFAULT: 15
      },
      id: '13.tableClothes-ret-div-3'
    }, {
      name: 'Doublure : ajout / remplacement',
      prices: {
        DEFAULT: 35
      },
      id: '13.tableClothes-ret-div-4'
    }, {
      name: 'Passant (x1) : ajout / remplacement',
      prices: {
        DEFAULT: 4
      },
      id: '13.tableClothes-ret-div-5',
      multiple: true
    }, {
      name: 'Pince (x1) : ajout',
      prices: {
        DEFAULT: 8
      },
      id: '13.tableClothes-ret-div-6',
      multiple: true
    }, {
      name: 'Fente : ajout / retrait',
      prices: {
        DEFAULT: 12
      },
      id: '13.tableClothes-ret-div-7'
    }, {
      name: 'Élastique : ajout',
      prices: {
        DEFAULT: 7
      },
      id: '13.tableClothes-ret-div-8'
    }, {
      name: 'Perlage (5 à 10 perles)',
      prices: {
        DEFAULT: 15
      },
      id: '13.tableClothes-ret-div-9',
      multiple: true
    }, {
      name: 'Poche (x1) : changement de doublure',
      prices: {
        DEFAULT: 17
      },
      id: '13.tableClothes-ret-div-10',
      multiple: true
    }, {
      name: 'Poche plate simple (x1) : ajout/retrait',
      prices: {
        DEFAULT: 10
      },
      id: '13.tableClothes-ret-div-11',
      multiple: true
    }, {
      name: 'Poche intérieure classique (x1) : ajout',
      prices: {
        DEFAULT: 15
      },
      id: '13.tableClothes-ret-div-12',
      multiple: true
    }, {
      name: 'Poche complexe (x1) : ajout',
      prices: {
        DEFAULT: 20
      },
      id: '13.tableClothes-ret-div-13',
      multiple: true
    }]
  }, {
    name: 'Réparer',
    slug: 'repair',
    subCategories: [(0, _commonPricings.getRepairInteriorTears)({
      slug: 'tableClothes'
    }), (0, _commonPricings.getRepairInteriorZips)({
      slug: 'tableClothes'
    }), (0, _commonPricings.getRepairInteriorButtons)({
      slug: 'tableClothes'
    })]
  }, {
    name: 'Broder',
    slug: 'embroidery',
    subCategories: [(0, _commonPricings.getEmbroideryPricingsCategory)('tableClothes', 'SIMPLE'), (0, _commonPricings.getCommunMachineEmbroidery)({
      slug: 'tableClothes'
    })]
  }]
}, {
  name: 'Autre',
  slug: 'autr',
  hasMostCommonCategory: false,
  types: undefined,
  categories: [{
    name: 'Divers',
    slug: 'divers',
    items: [{
      name: '1h de conseil basique',
      prices: {
        DEFAULT: 20
      },
      id: '13.autr-div-1'
    }, {
      name: 'Prise de mesure',
      prices: {
        DEFAULT: 20
      },
      id: '13.autr-div-2'
    }, {
      name: '1h de conseil robe de mariée',
      prices: {
        DEFAULT: 60
      },
      id: '13.autr-div-3'
    }, {
      name: '1h de conseil tailleur',
      prices: {
        DEFAULT: 50
      },
      id: '13.autr-div-4'
    }, {
      name: '1h de conseil broderie, maille , sport & bain',
      prices: {
        DEFAULT: 30
      },
      id: '13.autr-div-5'
    }, {
      name: '1h de conseil onboarding',
      prices: {
        DEFAULT: 35
      },
      id: '13.autr-div-6'
    }]
  }]
}, {
  name: 'Création de totebag',
  slug: 'crea_tote',
  hasMostCommonCategory: false,
  autoId: true,
  isSuitableForJunior: true,
  types: [{
    slug: 'SIMPLE_SMALL',
    name: 'Forme simple - classique : côtés < 50 cm'
  }, {
    slug: 'COMPLEX_SMALL',
    name: 'Forme originale - classique : côtés < 50 cm'
  }, {
    slug: 'SIMPLE_BIG',
    name: 'Forme simple - grand : côtés > 51 cm'
  }, {
    slug: 'COMPLEX_BIG',
    name: 'Forme originale - grand : côtés > 51 cm'
  }],
  autoComplexFactor: 2,
  autoPrices: true,
  categories: [{
    name: 'Dimensions',
    slug: 'sizes',
    autoIdPrefix: 'dime',
    items: [{
      name: 'Classique : côtés < 50 cm',
      prices: {
        SIMPLE_SMALL: 10
      }
    }, {
      name: 'Grand : côtés > 51 cm',
      prices: {
        SIMPLE_BIG: 15
      }
    }]
  }, {
    name: 'Anses',
    slug: 'handles',
    autoIdPrefix: 'anse',
    items: [{
      name: 'Chaîne + oeillets',
      prices: {
        SIMPLE_SMALL: 15,
        SIMPLE_BIG: 15
      }
    }, {
      name: 'Tissu',
      prices: {
        SIMPLE_SMALL: 2,
        SIMPLE_BIG: 3
      }
    }, {
      name: 'Autre / fourni par le client',
      prices: {
        SIMPLE_SMALL: 2,
        SIMPLE_BIG: 2
      }
    }]
  }, {
    name: 'Fermetures',
    slug: 'closures',
    autoIdPrefix: 'ferm',
    autoMultiple: true,
    items: (0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_tote',
      autoComplexFactor: 1,
      isClosingsOnly: true
    })
  }, {
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    autoMultiple: true,
    items: [{
      name: 'Doublure',
      prices: {
        SIMPLE_SMALL: 9,
        SIMPLE_BIG: 9
      }
    }, {
      name: 'Molleton',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_BIG: 7
      }
    }, {
      name: 'Thermocollant',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_BIG: 7
      }
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_tote',
      autoComplexFactor: 1
    })))
  }]
}, {
  name: 'Création de sac',
  slug: 'crea_sac',
  hasMostCommonCategory: false,
  autoId: true,
  isSuitableForJunior: true,
  types: [{
    slug: 'SIMPLE_SMALL',
    name: 'Forme simple - petit : côtés < 35 cm'
  }, {
    slug: 'COMPLEX_SMALL',
    name: 'Forme originale - petit : côtés < 35 cm'
  }, {
    slug: 'SIMPLE_MEDIUM',
    name: 'Forme simple - moyen : 36 cm < côtés < 50 cm'
  }, {
    slug: 'COMPLEX_MEDIUM',
    name: 'Forme originale - moyen : 36 cm < côtés < 50 cm'
  }, {
    slug: 'SIMPLE_BIG',
    name: 'Forme simple : côtés > 51 cm'
  }, {
    slug: 'COMPLEX_BIG',
    name: 'Forme originale : côtés > 51 cm'
  }],
  autoComplexFactor: 2,
  autoPrices: true,
  categories: [{
    name: 'Dimensions',
    slug: 'sizes',
    autoIdPrefix: 'dime',
    items: [{
      name: 'Petit : côtés < 35 cm',
      prices: {
        SIMPLE_SMALL: 10
      }
    }, {
      name: 'Moyen : 36 cm < côtés < 50 cm',
      prices: {
        SIMPLE_MEDIUM: 15
      }
    }, {
      name: 'Grand : côtés > 51 cm',
      prices: {
        SIMPLE_BIG: 20
      }
    }]
  }, {
    name: 'Anses',
    slug: 'handles',
    autoIdPrefix: 'anse',
    items: [{
      name: 'Chaîne + oeillets',
      prices: {
        SIMPLE_SMALL: 15,
        SIMPLE_MEDIUM: 15,
        SIMPLE_BIG: 15
      }
    }, {
      name: 'Tissu',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_MEDIUM: 5,
        SIMPLE_BIG: 5
      }
    }, {
      name: 'Autre / fourni par le client',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_MEDIUM: 5,
        SIMPLE_BIG: 5
      }
    }]
  }, {
    name: 'Fermetures',
    slug: 'closures',
    autoIdPrefix: 'ferm',
    autoMultiple: true,
    items: (0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_sac',
      autoComplexFactor: 1,
      isClosingsOnly: true
    })
  }, {
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    autoMultiple: true,
    items: [{
      name: 'Doublure',
      prices: {
        SIMPLE_SMALL: 9,
        SIMPLE_MEDIUM: 9,
        SIMPLE_BIG: 9
      }
    }, {
      name: 'Molleton',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_MEDIUM: 6,
        SIMPLE_BIG: 8
      }
    }, {
      name: 'Thermocollant',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_MEDIUM: 6,
        SIMPLE_BIG: 8
      }
    }, {
      name: 'Clous de protection',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_MEDIUM: 7,
        SIMPLE_BIG: 10
      }
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_sac',
      autoComplexFactor: 1
    })))
  }]
}, {
  name: 'Création de pochette',
  slug: 'crea_poch',
  hasMostCommonCategory: false,
  autoId: true,
  isSuitableForJunior: true,
  types: [{
    slug: 'SIMPLE_SMALL',
    name: 'Forme simple - petit (15x10cm)'
  }, {
    slug: 'COMPLEX_SMALL',
    name: 'Forme originale - petit (15x10cm)'
  }, {
    slug: 'SIMPLE_MEDIUM',
    name: 'Forme simple - moyen (20x20cm)'
  }, {
    slug: 'COMPLEX_MEDIUM',
    name: 'Forme originale - moyen (20x20cm)'
  }, {
    slug: 'SIMPLE_BIG',
    name: 'Forme simple - grand (>25cm)'
  }, {
    slug: 'COMPLEX_BIG',
    name: 'Forme originale - grand (>25cm)'
  }],
  autoComplexFactor: 2,
  autoPrices: true,
  categories: [{
    name: 'Dimensions',
    slug: 'sizes',
    autoIdPrefix: 'dime',
    items: [{
      name: 'Petit 15x10cm',
      prices: {
        SIMPLE_SMALL: 7
      }
    }, {
      name: 'Moyen 20x20cm',
      prices: {
        SIMPLE_MEDIUM: 12
      }
    }, {
      name: 'Grand > 25cm',
      prices: {
        SIMPLE_BIG: 18
      }
    }]
  }, {
    name: 'Anses',
    slug: 'handles',
    autoIdPrefix: 'anse',
    items: [{
      name: 'Chaîne + oeillets',
      prices: {
        SIMPLE_SMALL: 15,
        SIMPLE_MEDIUM: 15,
        SIMPLE_BIG: 15
      }
    }, {
      name: 'Tissu',
      prices: {
        SIMPLE_SMALL: 2,
        SIMPLE_MEDIUM: 2,
        SIMPLE_BIG: 2
      }
    }, {
      name: 'Autre / fourni par le client',
      prices: {
        SIMPLE_SMALL: 2,
        SIMPLE_MEDIUM: 2,
        SIMPLE_BIG: 2
      }
    }]
  }, {
    name: 'Fermetures',
    slug: 'closures',
    autoIdPrefix: 'ferm',
    autoMultiple: true,
    items: (0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_poch',
      autoComplexFactor: 1,
      isClosingsOnly: true
    })
  }, {
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    autoMultiple: true,
    items: [{
      name: 'Doublure',
      prices: {
        SIMPLE_SMALL: 9,
        SIMPLE_MEDIUM: 9,
        SIMPLE_BIG: 9
      }
    }, {
      name: 'Molleton',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_MEDIUM: 7,
        SIMPLE_BIG: 8
      }
    }, {
      name: 'Thermocollant',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_MEDIUM: 7,
        SIMPLE_BIG: 8
      }
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_poch',
      autoComplexFactor: 1
    })))
  }]
}, {
  name: 'Création de housse de coussin',
  slug: 'crea_hous',
  autoId: true,
  hasMostCommonCategory: false,
  isSuitableForJunior: true,
  types: [{
    slug: 'SIMPLE_SMALL',
    name: 'Forme simple - petit (<45cm)'
  }, {
    slug: 'COMPLEX_SMALL',
    name: 'Forme originale - petit (<45cm)'
  }, {
    slug: 'SIMPLE_BIG',
    name: 'Forme simple - grand (>45cm)'
  }, {
    slug: 'COMPLEX_BIG',
    name: 'Forme originale - grand (>45cm)'
  }],
  autoComplexFactor: 2,
  autoPrices: true,
  categories: [{
    name: 'Dimensions',
    slug: 'sizes',
    autoIdPrefix: 'dime',
    items: [{
      name: 'Petit < 45cm',
      prices: {
        SIMPLE_SMALL: 14
      }
    }, {
      name: 'Grand > 45cm',
      prices: {
        SIMPLE_BIG: 18
      }
    }]
  }, {
    name: 'Fermetures',
    slug: 'closures',
    autoIdPrefix: 'ferm',
    autoMultiple: true,
    items: (0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_hous',
      autoComplexFactor: 1,
      isClosingsOnly: true
    })
  }, {
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    autoMultiple: true,
    items: [{
      name: 'Doublure',
      prices: {
        SIMPLE_SMALL: 9,
        SIMPLE_BIG: 9
      }
    }, {
      name: 'Molleton',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_BIG: 8
      }
    }, {
      name: 'Thermocollant',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_BIG: 8
      }
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_hous',
      autoComplexFactor: 1
    })))
  }]
}, {
  name: 'Création de housse d’assise',
  slug: 'crea_assi',
  types: (0, _sofaCreation.getSeatAndBackTypes)(),
  subTypes: _sofaCreation.seatAndBackSubTypes,
  autoId: true,
  hasMostCommonCategory: false,
  autoPrices: true,
  categories: [{
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    items: [{
      name: 'Passepoil',
      priceForAllTypes: 20,
      multiple: true
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_assi'
    })))
  }]
}, {
  name: 'Création de housse de dossier',
  slug: 'crea_doss',
  types: (0, _sofaCreation.getSeatAndBackTypes)(false),
  subTypes: _sofaCreation.seatAndBackSubTypes,
  autoId: true,
  hasMostCommonCategory: false,
  autoPrices: true,
  categories: [{
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    items: [{
      name: 'Passepoil',
      priceForAllTypes: 20,
      multiple: true
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_doss'
    })))
  }]
}, {
  name: 'Création de housse de canapé',
  slug: 'crea_cana',
  types: (0, _sofaCreation.getSofaTypes)(),
  subTypes: _sofaCreation.sofaSubTypes,
  autoId: true,
  hasMostCommonCategory: false,
  autoPrices: true,
  categories: [{
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    items: [{
      name: 'Liens accoudoirs (x2)',
      priceForAllTypes: 15,
      multiple: true
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_cana'
    })))
  }]
}, {
  name: 'Création de plaid/couvre-lit',
  slug: 'crea_plai',
  autoId: true,
  hasMostCommonCategory: false,
  autoPrices: true,
  isSuitableForJunior: true,
  types: [{
    slug: 'SMALL',
    name: 'Petit (côté inférieur à < 99cm)'
  }, {
    slug: 'MEDIUM',
    name: 'Moyen (côté inférieur à < 199cm)'
  }, {
    slug: 'BIG',
    name: 'Grand (côté inférieur à < 300cm)'
  }],
  categories: [{
    name: 'Dimensions',
    slug: 'sizes',
    autoIdPrefix: 'dime',
    items: [{
      name: 'Petit < 99cm',
      prices: {
        SMALL: 33
      }
    }, {
      name: 'Moyen < 199cm',
      prices: {
        MEDIUM: 54
      }
    }, {
      name: 'Grand < 300cm',
      prices: {
        BIG: 75
      }
    }]
  }, {
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    items: [{
      name: 'Doublure',
      prices: {
        SMALL: 5,
        MEDIUM: 12,
        BIG: 15
      }
    }, {
      name: 'Molleton fourni par le Tilliste',
      prices: {
        SMALL: 23,
        MEDIUM: 47,
        BIG: 76
      }
    }, {
      name: 'Molleton',
      prices: {
        SMALL: 13,
        MEDIUM: 17,
        BIG: 21
      }
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_plai'
    })))
  }]
}, {
  name: 'Création de housse de chaise',
  slug: 'crea_chai',
  autoId: true,
  hasMostCommonCategory: false,
  autoPrices: true,
  isSuitableForJunior: true,
  types: [{
    slug: 'SMALL',
    name: 'Sans accoudoirs'
  }, {
    slug: 'BIG',
    name: 'Avec accoudoirs'
  }],
  categories: [{
    name: 'Accoudoirs',
    slug: 'armrests',
    autoIdPrefix: 'acco',
    items: [{
      name: 'Sans accoudoirs',
      prices: {
        SMALL: 34
      }
    }, {
      name: 'Avec accoudoirs',
      prices: {
        BIG: 64
      }
    }]
  }, {
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    autoMultiple: true,
    items: [{
      name: 'Housse jupe longue',
      priceForAllTypes: 12,
      multiple: true
    }, {
      name: 'Liens accoudoirs (x2)',
      priceForAllTypes: 15,
      multiple: true
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_chai'
    })))
  }]
}, {
  name: 'Création de housse de tabouret/pouf',
  slug: 'crea_stoo',
  autoId: true,
  hasMostCommonCategory: false,
  autoPrices: true,
  isSuitableForJunior: true,
  types: [{
    slug: 'SMALL',
    name: 'Petit (grand côté < 50cm)'
  }, {
    slug: 'BIG',
    name: 'Grand (grand côté > 50cm)'
  }],
  categories: [{
    name: 'Dimensions',
    slug: 'sizes',
    autoIdPrefix: 'dime',
    items: [{
      name: 'Petit (grand côté < 50cm)',
      prices: {
        SMALL: 26
      }
    }, {
      name: 'Grand (grand côté > 50cm)',
      prices: {
        BIG: 36
      }
    }]
  }, {
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    autoMultiple: true,
    items: [{
      name: 'Liens accoudoirs (x2)',
      priceForAllTypes: 15,
      multiple: true
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_stoo'
    })))
  }]
}, {
  name: 'Création de rideaux',
  slug: 'crea_ride',
  hasMostCommonCategory: false,
  autoId: true,
  isSuitableForJunior: true,
  types: [{
    slug: 'SIMPLE_SMALL',
    name: 'Un seul rideau - tringle < 140 cm'
  }, {
    slug: 'SIMPLE_MEDIUM',
    name: 'Un seul rideau - tringle < 200 cm'
  }, {
    slug: 'SIMPLE_BIG',
    name: 'Un seul rideau - tringle < 300 cm'
  }, {
    slug: 'SIMPLE_HUGE',
    name: 'Un seul rideau - tringle < 400 cm'
  }, {
    slug: 'COMPLEX_SMALL',
    name: 'Paire de rideaux - tringle < 140 cm'
  }, {
    slug: 'COMPLEX_MEDIUM',
    name: 'Paire de rideaux - tringle < 200 cm'
  }, {
    slug: 'COMPLEX_BIG',
    name: 'Paire de rideaux - tringle < 300 cm'
  }, {
    slug: 'COMPLEX_HUGE',
    name: 'Paire de rideaux - tringle < 400 cm'
  }],
  autoComplexFactor: 1,
  autoPrices: true,
  categories: [{
    name: 'Longueur rideau',
    slug: 'ride_length',
    autoIdPrefix: 'dime',
    items: [{
      name: 'Tringle < 140 cm',
      prices: {
        SIMPLE_SMALL: 50
      },
      autoComplexFactor: 1.4
    }, {
      name: 'Tringle < 200 cm',
      prices: {
        SIMPLE_MEDIUM: 80
      },
      autoComplexFactor: 1.25
    }, {
      name: 'Tringle < 300 cm',
      prices: {
        SIMPLE_BIG: 120
      },
      autoComplexFactor: 1.25
    }, {
      name: 'Tringle < 400 cm',
      prices: {
        SIMPLE_HUGE: 150
      },
      autoComplexFactor: 1.2
    }]
  }, {
    name: 'Hauteur rideau',
    slug: 'ride_height',
    autoIdPrefix: 'haut',
    items: [{
      name: 'Court (hauteur < à 200 cm)',
      prices: {
        SIMPLE_SMALL: 0,
        SIMPLE_MEDIUM: 0,
        SIMPLE_BIG: 0,
        SIMPLE_HUGE: 0
      }
    }, {
      name: 'Moyen (hauteur < à 300 cm)',
      prices: {
        SIMPLE_SMALL: 10,
        SIMPLE_MEDIUM: 20,
        SIMPLE_BIG: 30,
        SIMPLE_HUGE: 40
      }
    }, {
      name: 'Long (hauteur < à 400 cm)',
      prices: {
        SIMPLE_SMALL: 14,
        SIMPLE_MEDIUM: 28,
        SIMPLE_BIG: 42,
        SIMPLE_HUGE: 56
      }
    }]
  }, {
    name: 'Tête de rideau',
    slug: 'ride_head',
    autoIdPrefix: 'tete',
    items: [{
      name: 'Ruban passants cachés',
      prices: {
        SIMPLE_SMALL: 30,
        SIMPLE_MEDIUM: 30,
        SIMPLE_BIG: 37,
        SIMPLE_HUGE: 37
      }
    }, {
      name: 'Pattes apparentes',
      prices: {
        SIMPLE_SMALL: 56,
        SIMPLE_MEDIUM: 80,
        SIMPLE_BIG: 120,
        SIMPLE_HUGE: 160
      }
    }, {
      name: 'Galon fronceur',
      prices: {
        SIMPLE_SMALL: 30,
        SIMPLE_MEDIUM: 30,
        SIMPLE_BIG: 37,
        SIMPLE_HUGE: 37
      }
    }, {
      name: 'Nouettes',
      prices: {
        SIMPLE_SMALL: 56,
        SIMPLE_MEDIUM: 80,
        SIMPLE_BIG: 120,
        SIMPLE_HUGE: 160
      }
    }]
  }, {
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    autoMultiple: true,
    items: [{
      name: 'Doublure',
      prices: {
        SIMPLE_SMALL: 20,
        SIMPLE_MEDIUM: 30,
        SIMPLE_BIG: 40,
        SIMPLE_HUGE: 50,
        COMPLEX_SMALL: 30,
        COMPLEX_MEDIUM: 40,
        COMPLEX_BIG: 50,
        COMPLEX_HUGE: 60
      }
    }, {
      name: 'Supplément fil de plomb',
      priceForAllTypes: 10,
      multiple: true
    }, {
      name: 'Dépose/pose d’un pan de rideau',
      priceForAllTypes: 10,
      multiple: true
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_ride',
      autoComplexFactor: 1
    })))
  }]
}];
var _default = exports["default"] = rawPricing;